!(function (t) {
    var e,
        a,
        o,
        i = t("body"),
        n = t(document),
        r = t("html"),
        s = t(window),
        d = t("#sidebar-cart"),
        l = (d.find(".btn-remove"), d.find(".cart-empty")),
        c = d.find(".mini-products-list"),
        p = d.find(".cart-footer"),
        u = localStorage.getItem("items") ? JSON.parse(localStorage.getItem("items")) : [],
        h = localStorage.getItem("compareArr") ? JSON.parse(localStorage.getItem("compareArr")) : [];
    localStorage.setItem("items", JSON.stringify(u)),
        localStorage.setItem("compareArr", JSON.stringify(h)),
        u.length && (u = JSON.parse(localStorage.getItem("items"))),
        h.length && (h = JSON.parse(localStorage.getItem("compareArr"))),
        n.ready(function () {
            (e = t("[data-menu-mb-toogle]")),
                (a = t("#dropdown-cart")),
                (o = a.find(".mini-products-list")),
                n.ajaxStart(function () {
                    m.isAjaxLoading = !0;
                }),
                n.ajaxStop(function () {
                    m.isAjaxLoading = !1;
                }),
                m.init();
        });
    var f = s.innerWidth();
    s.off("resize.initMenuMobile").on("resize.initMenuMobile", function () {
        var e;
        clearTimeout(e),
            (e = setTimeout(function () {
                var e = s.innerWidth();
                ((e < 1200 && f >= 1200) || (e >= 1200 && f < 1200)) &&
                    (m.showHideMenuMobile(),
                    m.initToggleMuiltiLangCurrency(),
                    m.addTextMuiltiOptionActive(t("#lang-switcher"), t("#lang-switcher [data-value].active"), t("[data-language-label]")),
                    m.addTextMuiltiOptionActive(t("#currencies"), t("#currencies [data-currency].active"), t("[data-currency-label]")),
                    m.initDropdownColFooter(),
                    m.dropdownCart(),
                    m.dropdownCustomer(),
                    m.stickyFixedTopMenu()),
                    (f = e);
            }, 0));
    }),
        s.on("resize", function () {
            m.setActiveViewModeMediaQuery();
        });
    var m = {
        ellaTimeout: null,
        isSidebarAjaxClick: !1,
        isAjaxLoading: !1,
        init: function () {
            this.closeHeaderTop(),
                this.showHideMenuMobile(),
                this.closeAllOnMobile(),
                this.initToggleGlobe(),
                this.initToggleMuiltiLangCurrency(),
                this.addTextMuiltiOptionActive(t("#lang-switcher"), t("#lang-switcher [data-value].active"), t("[data-language-label]")),
                this.addTextMuiltiOptionActive(t("#currencies"), t("#currencies [data-currency].active"), t("[data-currency-label]")),
                this.initDropdownColFooter(),
                this.initScrollTop(),
                this.dropdownCart(),
                this.initColorSwatchGrid(),
                this.loadJsonProductcard(),
                this.initQuickshop(),
                this.initToggleSubMenuMobile(),
                this.dropdownCustomer(),
                this.initNewsLetterPopup(),
                this.addEventShowOptions(),
                this.changeQuantityAddToCart(),
                this.initAddToCart(),
                this.editCart(),
                this.beforeYouLeave(),
                this.initFreeShippingMessage(),
                this._videoPopup(),
                this.initProductReview(),
                i.hasClass("template-index") || (this.initGroupedAddToCart(), this.initSliderFeaturedProducts()),
                t("[data-lookbook-icon]").length && this.addEventLookbookModal(),
                t("[data-countdown]").length && this.initCountdown(),
                this.initCountdownNormal(),
                this.checkbox_checkout(),
                i.hasClass("template-page") && (this.collectionProduct(), this.CollectionMenu()),
                this.menu_ajax(),
                this.loaderScript(),
                //i.hasClass("template-index") && (this.initInfiniteScrollingHomepage(), t("[data-home-product-tabs]").length && this.clickedActiveProductTabs(), t("[data-scroll-down]").length && this.handleScrollDown()),
                (i.hasClass("template-collection") || i.hasClass("template-search")) &&
                    (this.historyAdapter(), this.initInfiniteScrolling(), this.initPaginationPage(), this.initCompareIcons(), this.doAddOrRemoveCompare(), this.initCompareSelected()),
                i.hasClass("template-collection") && (this.filterToolbar(), this.filterSidebar(), this.toggleVariantsForExpressOrder(), this.initExpressOrderAddToCart(), this.hide_filter(), this.initSidebar()),
                this.initChangeQuantityButtonEvent(),
                this.initQuantityInputChangeEvent(),
                this.removeCartItem(),
                this.initQuickView(),
                this.stickyFixedTopMenu(),
                this.openSearchForm(),
                i.hasClass("template-product") &&
                    (this.initCustomerViewProductShop(),
                    this.initProductMoreview(t("[data-more-view-product] .product-img-box")),
                    this.initZoom(),
                    this.initSoldOutProductShop(),
                    this.productPageInitProductTabs(),
                    this.changeSwatch("#add-to-cart-form .swatch :radio"),
                    this.initStickyForProductFullWidth(),
                    this.initStickyAddToCart(),
                    this.wrapTable(),
                    this._addonCompareColorPopup(),
                    t(".frequently-bought-together-block").length > 0 && this.initBundleProducts(),
                    this.productRecomendation(),
                    this.appendProductRecomendation(),
                    this.initOpenSidebar(),
                    this.closeSidebar()),
                i.hasClass("template-cart") && (this.checkBundleProducts(), this._cartCountDown()),
                this.initWishListIcons(),
                this.doAddOrRemoveWishlish(),
                i.hasClass("template-page") && t(".wishlist-page").length && this.initWishLists();
        },
        sliderMegaMenu: function () {
            t(".featuredProductCarousel").length &&
                t(".featuredProductCarousel").slick({
                    infinite: !1,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: !1,
                    arrows: !0,
                    autoplay: !1,
                    nextArrow:
                        '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"/></svg></button>',
                    prevArrow:
                        '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"/></svg></button>',
                    speed: 1e3,
                    responsive: [
                        { breakpoint: 1450, settings: { slidesToShow: 4, slidesToScroll: 4, dots: !1, arrows: !0 } },
                        { breakpoint: 1281, settings: { slidesToShow: 4, slidesToScroll: 4, dots: !1, arrows: !0 } },
                        { breakpoint: 1025, settings: { slidesToShow: 2, slidesToScroll: 2, dots: !0, arrows: !1 } },
                        { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2, dots: !0, arrows: !1 } },
                        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2, dots: !0, arrows: !1 } },
                        { breakpoint: 370, settings: { slidesToShow: 2, slidesToScroll: 2, dots: !0, arrows: !1 } },
                    ],
                });
        },
        productCartslider: function () {
            t("[data-product-cart-slider]").length &&
                t("[data-product-cart-slider]").slick({
                    infinite: !1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    arrows: !1,
                    autoplay: !1,
                    nextArrow:
                        '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"/></svg></button>',
                    prevArrow:
                        '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"/></svg></button>',
                    speed: 1e3,
                });
        },
        closeHeaderTop: function () {
            var e = t(".header-top"),
                a = e.find("[data-close-header-top]");
            a.length &&
                a.is(":visible") &&
                ("closed" == t.cookie("headerTop") && e.remove(),
                a.off("click.closeHeaderTop").on("click.closeHeaderTop", function (a) {
                    a.preventDefault(), a.stopPropagation(), e.remove(), t.cookie("headerTop", "closed", { expires: 1, path: "/" });
                }));
        },
        showHideMenuMobile: function () {
            e.length &&
                e.is(":visible") &&
                e.off("click.showMenuMobile").on("click.showMenuMobile", function (e) {
                    e.preventDefault(),
                        e.stopPropagation(),
                        r.toggleClass("translate-overlay"),
                        t(".close-menu-mb").toggleClass("menu-open"),
                        t(".main-menu.jas-mb-style").css({ overflow: "" }),
                        t(".site-nav").find("[data-toggle-menu-mb]").parent().next(".sub-menu-mobile").removeClass("sub-menu-open");
                });
        },
        closeAllOnMobile: function () {
            i.off("click.close", ".wrapper-overlay").on("click.close", ".wrapper-overlay", function (e) {
                e.preventDefault(),
                    e.stopPropagation(),
                    r.removeClass("translate-overlay cart-show customer-show sidebar-open options-show"),
                    t(".close-menu-mb").removeClass("menu-open"),
                    t(".main-menu.jas-mb-style").css({ overflow: "" }),
                    t(".site-nav").find("[data-toggle-menu-mb]").parent().next(".sub-menu-mobile").removeClass("sub-menu-open"),
                    t("body").hasClass("open_beforeYouLeave") && 0 === t(e.target).closest("#before-you-leave").length && 0 === t(e.target).closest(".search-form-wrapper").length && t("body").removeClass("open_beforeYouLeave");
            });
        },
        initToggleGlobe: function () {
            t(".wrapper-icon").on("click", function (e) {
                t(this).parent().toggleClass("active"), t(".lang-currency-groups").slideUp(400), t(".item-location").hasClass("active") && t(".lang-currency-groups").slideDown(400), m.initToggleMuiltiLangCurrency();
            }),
                i.on("click", function (e) {
                    t(".item-location").hasClass("active") && 0 === t(event.target).closest(".item-location").length && (e.preventDefault(), t(".item-location").removeClass("active"), t(".lang-currency-groups").slideUp(400));
                });
        },
        initToggleMuiltiLangCurrency: function () {
            var e = t(".lang-currency-groups").find(".btn-group").find(".dropdown-label");
            e.length && e.is(":visible")
                ? (e.off("click.toggleMuiltiOption").on("click.toggleMuiltiOption", function (a) {
                      a.preventDefault(), a.stopPropagation();
                      var o = t(this).next();
                      o.is(":visible") ? o.slideUp(300) : (e.next(".dropdown-menu").hide(), o.slideDown(300));
                  }),
                  m.hideMuiltiLangCurrency())
                : e.next(".dropdown-menu").css({ display: "" });
        },
        hideMuiltiLangCurrency: function () {
            n.off("click.hideMuiltiLangCurrency").on("click.hideMuiltiLangCurrency", function (e) {
                var a = t(".lang-currency-groups .dropdown-menu");
                a.is(e.target) || a.has(e.target).length || a.slideUp(300);
            });
        },
        addTextMuiltiOptionActive: function (t, e, a) {
            if (a.length && a.is(":visible")) {
                var o = e.html();
                t.prev(a).html(o);
            }
        },
        initInfiniteScrollingHomepage: function () {
            t("[data-new-arrivals-product]").each(function () {
                var e = t(this),
                    a = e.find(".infinite-scrolling-homepage"),
                    o = e.find(".infinite-scrolling-homepage a");
                a.length &&
                    o.off("click.showMoreProduct").on("click.showMoreProduct", function (a) {
                        if (!t(this).hasClass("view-all-collection")) {
                            if ((a.preventDefault(), a.stopPropagation(), t(this).hasClass("ajax-loading"))) return !1;
                            t(this).addClass("ajax-loading");
                            var o = t(this).attr("data-collection"),
                                i = t(this).attr("data-limit"),
                                n = t(this).attr("data-total-products"),
                                r = parseInt(t(this).attr("data-page"));
                            t(this).hasClass("disabled") || m.doAjaxInfiniteScrollingGetContentSection(n, o, i, r, a, e);
                        }
                    });
            });
        },
        doAjaxInfiniteScrollingGetContentSection(e, a, o, i, n, r) {
            t.ajax({
                type: "get",
                url: window.router + "/collections/" + a,
                cache: !1,
                data: { view: "sorting", constraint: "limit=" + o + "+page=" + i },
                beforeSend: function () {
                    m.showLoading();
                },
                success: function (s) {
                    r.find(".products-grid").append(s);
                    var d = r.find(".products-grid").find(".grid-item").length;
                    if (
                        (t(s).length == o && d < 50
                            ? t(n.currentTarget).attr("data-page", i + 1)
                            : e > 50
                            ? t(n.currentTarget)
                                  .text(window.inventory_text.view_all_collection)
                                  .attr("href", window.router + "/collections/" + a)
                                  .addClass("view-all-collection")
                            : t(n.currentTarget).remove(),
                        m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                        t(".shopify-product-reviews-badge").length && t(".spr-badge").length)
                    )
                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                },
                complete: function () {
                    m.hideLoading(), t(n.currentTarget).removeClass("ajax-loading");
                },
            });
        },
        initSliderFeaturedProducts: function () {
            t("[data-featured-products]").each(function () {
                var e = t(this),
                    a = e.find(".products-grid"),
                    o = a.data("row"),
                    i = t(".halo-product-content .pro-page [data-has-right-sidebar]");
                a.hasClass("slick-initialized") ||
                    a.slick({
                        get slidesToShow() {
                            return i.length ? (this.slidesToShow = 5) : (this.slidesToShow = a.data("row"));
                        },
                        get vertical() {
                            return a.hasClass("verticle") ? (this.vertical = !0) : (this.vertical = !1);
                        },
                        get slidesToScroll() {
                            return a.hasClass("verticle") ? (this.slidesToScroll = 1) : (this.slidesToScroll = a.data("row"));
                        },
                        speed: 1e3,
                        infinite: !1,
                        get dots() {
                            return e.hasClass("has-banner") ? (this.dots = !0) : (this.dots = !1);
                        },
                        get nextArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.nextArrow =
                                      '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>');
                        },
                        get prevArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.prevArrow =
                                      '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>');
                        },
                        responsive: [
                            {
                                breakpoint: 1400,
                                settings: {
                                    get slidesToShow() {
                                        return e.hasClass("has-banner") ? (this.slidesToShow = 3) : (this.slidesToShow = o > 5 ? 5 : a.data("row"));
                                    },
                                    get slidesToScroll() {
                                        return e.hasClass("has-banner")
                                            ? (this.slidesToScroll = 3)
                                            : a.hasClass("verticle")
                                            ? (this.slidesToScroll = 1)
                                            : o >= 4
                                            ? (this.slidesToScroll = 4)
                                            : (o = 3)
                                            ? (this.slidesToScroll = 3)
                                            : (this.slidesToScroll = 2);
                                    },
                                },
                            },
                            {
                                breakpoint: 1200,
                                settings: {
                                    dots: !0,
                                    arrows: !1,
                                    vertical: !1,
                                    get slidesToShow() {
                                        return e.hasClass("has-banner") ? (this.slidesToShow = 2) : o >= 4 ? (this.slidesToShow = 4) : (o = 3) ? (this.slidesToShow = 3) : (this.slidesToShow = 2);
                                    },
                                    get slidesToScroll() {
                                        return e.hasClass("has-banner") ? (this.slidesToScroll = 2) : o >= 4 ? (this.slidesToScroll = 4) : (o = 3) ? (this.slidesToScroll = 3) : (this.slidesToScroll = 2);
                                    },
                                },
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    dots: !0,
                                    arrows: !1,
                                    vertical: !1,
                                    get slidesToShow() {
                                        return (this.slidesToShow = o >= 3 ? 3 : 2);
                                    },
                                    get slidesToScroll() {
                                        return (this.slidesToScroll = o >= 3 ? 3 : 2);
                                    },
                                },
                            },
                            { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2, arrows: !1, vertical: !1, dots: !0 } },
                        ],
                    });
            });
        },
        loaderProductCard: function () {
            t(document).ajaxStart(function () {
                !0;
            }),
                t(document).ajaxStop(function () {
                    !1;
                });
            var e = t("[data-loader-product]"),
                a = function () {
                    e.each(function () {
                        var e = this.getBoundingClientRect().top,
                            a = t(this);
                        if (!a.hasClass("ajax-loaded")) {
                            var o = a.data("collection"),
                                i = a.data("limit"),
                                n = a.data("layout");
                            e < window.innerHeight + 400 &&
                                t.ajax({
                                    type: "get",
                                    url: window.router + "/collections/" + o,
                                    cache: !1,
                                    data: { view: "list_product", constraint: "limit=" + i + "+layout=" + n },
                                    beforeSend: function () {
                                        a.addClass("ajax-loaded");
                                    },
                                    success: function (t) {
                                        "" != o && a.find(".products-grid").append(t);
                                    },
                                    complete: function () {
                                        if ((a.addClass("active"), "carousel" == n)) {
                                            var e = a.find(".products-grid"),
                                                o = e.data("row"),
                                                i = t(".halo-product-content .pro-page [data-has-right-sidebar]");
                                            e.not(".slick-initialized") &&
                                                e.slick({
                                                    get slidesToShow() {
                                                        return i.length ? (this.slidesToShow = 5) : (this.slidesToShow = e.data("row"));
                                                    },
                                                    get vertical() {
                                                        return e.hasClass("verticle") ? (this.vertical = !0) : (this.vertical = !1);
                                                    },
                                                    get slidesToScroll() {
                                                        return e.hasClass("verticle") ? (this.slidesToScroll = 1) : (this.slidesToScroll = e.data("row"));
                                                    },
                                                    speed: 1e3,
                                                    infinite: !1,
                                                    get dots() {
                                                        return a.hasClass("has-banner") ? (this.dots = !0) : (this.dots = !1);
                                                    },
                                                    get nextArrow() {
                                                        return "layout_style_1170" == window.layout_style
                                                            ? (this.nextArrow =
                                                                  '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                                            : (this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>');
                                                    },
                                                    get prevArrow() {
                                                        return "layout_style_1170" == window.layout_style
                                                            ? (this.prevArrow =
                                                                  '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                                            : (this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>');
                                                    },
                                                    responsive: [
                                                        {
                                                            breakpoint: 1400,
                                                            settings: {
                                                                get slidesToShow() {
                                                                    return a.hasClass("has-banner") ? (this.slidesToShow = 3) : (this.slidesToShow = o > 5 ? 5 : e.data("row"));
                                                                },
                                                                get slidesToScroll() {
                                                                    return a.hasClass("has-banner")
                                                                        ? (this.slidesToScroll = 3)
                                                                        : e.hasClass("verticle")
                                                                        ? (this.slidesToScroll = 1)
                                                                        : o >= 4
                                                                        ? (this.slidesToScroll = 4)
                                                                        : (o = 3)
                                                                        ? (this.slidesToScroll = 3)
                                                                        : (this.slidesToScroll = 2);
                                                                },
                                                            },
                                                        },
                                                        {
                                                            breakpoint: 1200,
                                                            settings: {
                                                                dots: !0,
                                                                arrows: !1,
                                                                vertical: !1,
                                                                get slidesToShow() {
                                                                    return a.hasClass("has-banner") ? (this.slidesToShow = 2) : o >= 4 ? (this.slidesToShow = 4) : (o = 3) ? (this.slidesToShow = 3) : (this.slidesToShow = 2);
                                                                },
                                                                get slidesToScroll() {
                                                                    return a.hasClass("has-banner") ? (this.slidesToScroll = 2) : o >= 4 ? (this.slidesToScroll = 4) : (o = 3) ? (this.slidesToScroll = 3) : (this.slidesToScroll = 2);
                                                                },
                                                            },
                                                        },
                                                        {
                                                            breakpoint: 992,
                                                            settings: {
                                                                dots: !0,
                                                                arrows: !1,
                                                                vertical: !1,
                                                                get slidesToShow() {
                                                                    return (this.slidesToShow = o >= 3 ? 3 : 2);
                                                                },
                                                                get slidesToScroll() {
                                                                    return (this.slidesToScroll = o >= 3 ? 3 : 2);
                                                                },
                                                            },
                                                        },
                                                        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2, arrows: !1, vertical: !1, dots: !0 } },
                                                    ],
                                                });
                                        }
                                        if (
                                            (m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                                            t(".shopify-product-reviews-badge").length && t(".spr-badge").length)
                                        )
                                            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                                    },
                                });
                        }
                    });
                };
            window.addEventListener("load", function () {
                a(), window.addEventListener("scroll", a);
            });
        },
        collectionProduct: function () {
            t("[data-collection-product] .products-grid").each(function () {
                var e = t(this);
                e.not(".slick-initialized") &&
                    e.slick({
                        rows: 2,
                        slidesToShow: 2,
                        infinite: !1,
                        dots: !0,
                        speed: 800,
                        arrows: !1,
                        responsive: [
                            { breakpoint: 1200, settings: { slidesPerRow: 1, slidesToShow: 2, rows: 2 } },
                            { breakpoint: 992, settings: { slidesPerRow: 1, slidesToShow: 2, rows: 2 } },
                            { breakpoint: 768, settings: { slidesPerRow: 1, slidesToShow: 2, dots: !0, rows: 2 } },
                        ],
                    });
            });
        },
        CollectionMenu: function () {
            t("[data-collection-menu-slider]").each(function () {
                var e = t(this);
                e.not(".slick-initialized") &&
                    e.slick({
                        slidesToShow: e.data("rows"),
                        slidesToScroll: 1,
                        dots: !1,
                        infinite: !1,
                        speed: 800,
                        get nextArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.nextArrow =
                                      '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>');
                        },
                        get prevArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.prevArrow =
                                      '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>');
                        },
                        responsive: [
                            { breakpoint: 1200, settings: { slidesToShow: 6, slidesToScroll: 6 } },
                            { breakpoint: 992, settings: { slidesToShow: 5, slidesToScroll: 5 } },
                            { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                            { breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                        ],
                    });
            });
        },
        initDropdownColFooter: function () {
            var e = t(".site-footer .dropdow-mb");
            window.innerWidth < 768
                ? e.length &&
                  e.off("click.slideToggle").on("click.slideToggle", function () {
                      t(this).next().slideToggle(), t(this).toggleClass("open");
                  })
                : e.next().css({ display: "" });
        },
        initScrollTop: function () {
            var e = t("#back-top");
            s.scroll(function () {
                t(this).scrollTop() > 220 ? e.fadeIn(400) : e.fadeOut(400);
            }),
                e.off("click.scrollTop").on("click.scrollTop", function (e) {
                    return e.preventDefault(), e.stopPropagation(), t("html, body").animate({ scrollTop: 0 }, 400), !1;
                });
        },
        dropdownCustomer: function () {
            this.initDropdownCustomerTranslate(t("[data-user-mobile-toggle]"), "customer-show"),
                this.initDropdownCustomerTranslate(t(".header-05 .customer-links"), "customer-show"),
                window.innerWidth >= 1200 && this.initDropdownCustomerTranslate(t("[data-user-pc-translate]"), "customer-show"),
                this.closeDropdownCustomerTranslate(),
                this.initDropdownCustomer();
        },
        initDropdownCustomerTranslate: function (t, e) {
            t.length &&
                t.is(":visible") &&
                t.off("click.dropdownCustomerMobile").on("click.dropdownCustomerMobile", function (t) {
                    t.preventDefault(), t.stopPropagation(), r.addClass(e);
                });
        },
        closeTranslate: function (e, a) {
            t(e).length &&
                i.off("click.closeCustomer", e).on("click.closeCustomer", e, function (t) {
                    t.preventDefault(), t.stopPropagation(), r.removeClass(a);
                });
        },
        closeDropdownCustomerTranslate: function () {
            m.closeTranslate("#dropdown-customer .close-customer", "customer-show");
        },
        appendCustomerForPCHeaderDefault: function () {
            var e = t(".header-default .header-panel-bt .customer-links"),
                a = t("#dropdown-customer");
            window.innerWidth >= 1200 ? a.appendTo(e) : a.appendTo(i);
        },
        appendCustomerForPCHeader05: function () {
            t(".header-05 .header-panel-bt .customer-links");
            t("#dropdown-customer").appendTo(i);
        },
        doDropdownCustomerPCHeaderDefault: function () {
            var e = t("[data-dropdown-user]");
            window.innerWidth >= 1200 &&
                e.off("click.toogleCustomer").on("click.toogleCustomer", function (e) {
                    e.preventDefault(), e.stopPropagation(), t(this).siblings("#dropdown-customer").slideToggle();
                });
        },
        doDropdownCustomerPCHeader05: function () {
            t("[data-dropdown-user]")
                .off("click.toogleCustomer")
                .on("click.toogleCustomer", function (e) {
                    e.preventDefault(), e.stopPropagation(), t(this).siblings("#dropdown-customer").slideToggle();
                });
        },
        initDropdownCustomer: function () {
            var e = t(".site-header");
            e.hasClass("header-default") && (this.appendCustomerForPCHeaderDefault(), this.doDropdownCustomerPCHeaderDefault()), e.hasClass("header-05") && (this.appendCustomerForPCHeader05(), this.doDropdownCustomerPCHeader05());
        },
        dropdownCart: function () {
            this.closeDropdownCartTranslate(), this.initDropdownCartMobile(), this.initDropdownCartDesktop(), this.checkItemsInDropdownCart(), this.removeItemDropdownCart();
        },
        appendDropdownCartForMobile: function () {
            var e = t(".wrapper-top-cart");
            window.innerWidth < 1200 ? a.appendTo(i) : a.appendTo(e);
        },
        closeDropdownCartTranslate: function () {
            m.closeTranslate("#dropdown-cart .close-cart", "cart-show", "#reload_page");
        },
        initDropdownCartMobile: function () {
            var e = t(".header-mb, [data-cart-header-parallax], [data-cart-header-02], [data-cart-header-04], [data-cart-header-05], [data-cart-header-supermarket], [data-cart-sidebar]").find("[data-cart-toggle]");
            t("body.template-cart").length
                ? e.off("click.toogleDropdownCart").on("click.toogleDropdownCart", function (e) {
                      e.preventDefault(), e.stopPropagation(), t([document.documentElement, document.body]).animate({ scrollTop: t(".wrapper-cart-template").offset().top - t(".main-menu").outerHeight() }, 500);
                  })
                : e.off("click.initDropdownCartMobile").on("click.initDropdownCartMobile", function (t) {
                      t.preventDefault(), t.stopPropagation(), r.toggleClass("cart-show"), m.productCartslider();
                  });
        },
        initDropdownCartDesktop: function () {
            t(".site-header").hasClass("header-default-cart") && (m.appendDropdownCartForMobile(), m.initDropdownCartForHeaderDefault());
        },
        addEventShowOptions: function () {
            n.off("click.showOptions", "[data-show-options]").on("click.showOptions", "[data-show-options]", function (t) {
                t.preventDefault(), t.stopPropagation(), r.toggleClass("options-show");
            }),
                m.closeTranslate(".lang-currency-groups .close-option", "options-show");
        },
        initDropdownCartForHeaderDefault: function () {
            var e = t(".wrapper-top-cart"),
                o = e.find("[data-cart-toggle]");
            o.length && o.is(":visible")
                ? t("body.template-cart").length
                    ? o.off("click.toogleDropdownCart").on("click.toogleDropdownCart", function (e) {
                          e.preventDefault(), e.stopPropagation(), t([document.documentElement, document.body]).animate({ scrollTop: t(".wrapper-cart-template").offset().top - t(".main-menu").outerHeight() }, 1e3);
                      })
                    : "click" == window.dropdowncart_type
                    ? o.off("click.toogleDropdownCart").on("click.toogleDropdownCart", function (t) {
                          t.preventDefault(), t.stopPropagation(), e.toggleClass("is-open"), a.slideToggle();
                      })
                    : (o.hover(function () {
                          var o = t("#dropdown-customer");
                          o.is(":visible") && o.hide(), e.hasClass("is-open") || (e.addClass("is-open"), a.slideDown());
                      }),
                      e.mouseleave(function () {
                          e.hasClass("is-open") && (e.removeClass("is-open"), a.slideUp());
                      }))
                : a.css("display", "");
        },
        checkItemsInDropdownCart: function () {
            var t = a.find(".no-items"),
                e = a.find(".has-items");
            o.children().length ? (e.show(), t.hide(), l.hide(), c.show(), p.show()) : (e.hide(), t.show(), l.show(), c.hide(), p.hide());
        },
        removeItemDropdownCart: function (e) {
            var o = a.find(".btn-remove"),
                i = a.find(".item-quantity");
            o.off("click.removeCartItem").on("click.removeCartItem", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this).parents(".item").attr("id");
                (a = a.match(/\d+/g)),
                    Shopify.removeItem(a, function (e) {
                        t("#cart-item-" + a).remove(), t("#sidebar-cart-item-" + a).remove(), m.doUpdateDropdownCart(e), m.checkBundleProducts();
                    });
            }),
                i.off("change.addCartItem").on("change.addCartItem", function (e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = a.closest("[data-product-id]").data("product-id"),
                        i = parseInt(a.val());
                    m.doAjaxUpdatePopupCart(i, o);
                });
        },
        updateDropdownCart: function () {
            Shopify.getCart(function (t) {
                m.doUpdateDropdownCart(t);
            });
        },
        doUpdateDropdownCart: function (e) {
            if (
                (t("[data-cart-count]").text(e.item_count),
                t(".wrapper-cartCount").show(),
                a.find(".summary .price").html(Shopify.formatMoney(e.total_price, window.money_format)),
                t("#sidebar-cart").find(".cart-footer .notranslate").html(Shopify.formatMoney(e.total_price, window.money_format)),
                o.html(""),
                e.item_count > 0)
            ) {
                for (var i = 0; i < e.items.length; i++) {
                    var n =
                        '<li class="item" id="cart-item-{ID}" data-product-id="{ID}"><a href="{URL}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a class="product-name" href="{URL}">{TITLE}</a><div class="option"><small>{VARIANT}</small><a href="JavaScript:void(0);" class="product-details__edit" data-cart-edit aria-label="link" data-url="{URL}&view=cart_edit" data-id="{ID}" data-quantity="{QUANTITY}"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 48 48" width="144px" height="144px"><path d="M 10.5 6 C 7.468 6 5 8.468 5 11.5 L 5 36 C 5 39.309 7.691 42 11 42 L 22.605469 42 C 22.858469 41.042 23.225516 39.759 23.728516 38 L 11 38 C 9.897 38 9 37.103 9 36 L 9 16 L 39 16 L 39 22.521484 C 39.427 22.340484 39.8615 22.188422 40.3125 22.107422 C 40.7065 22.036422 41.102859 21.992953 41.505859 22.001953 C 42.015859 22.001953 42.515 22.067641 43 22.181641 L 43 11.5 C 43 8.468 40.532 6 37.5 6 L 10.5 6 z M 13.5 20 A 1.50015 1.50015 0 1 0 13.5 23 L 15.5 23 A 1.50015 1.50015 0 1 0 15.5 20 L 13.5 20 z M 21.5 20 C 20.672 20 20 20.671 20 21.5 C 20 22.329 20.672 23 21.5 23 L 34.5 23 C 35.328 23 36 22.329 36 21.5 C 36 20.671 35.328 20 34.5 20 L 21.5 20 z M 41.498047 24 C 41.224047 24.001 40.946969 24.025172 40.667969 24.076172 C 39.783969 24.235172 38.939563 24.696156 38.226562 25.410156 L 26.427734 37.208984 C 26.070734 37.565984 25.807969 38.011141 25.667969 38.494141 L 24.097656 43.974609 C 24.025656 44.164609 23.993 44.365406 24 44.566406 C 24.013 44.929406 24.155594 45.288406 24.433594 45.566406 C 24.710594 45.843406 25.067688 45.986 25.429688 46 C 25.630688 46.007 25.834391 45.975344 26.025391 45.902344 L 31.505859 44.332031 C 31.988859 44.192031 32.431062 43.930266 32.789062 43.572266 L 44.589844 31.773438 C 45.303844 31.060437 45.764828 30.216031 45.923828 29.332031 C 45.973828 29.053031 45.997047 28.775953 45.998047 28.501953 C 46.001047 27.307953 45.540687 26.179312 44.679688 25.320312 C 43.820687 24.460313 42.692047 23.998 41.498047 24 z M 13.5 26 A 1.50015 1.50015 0 1 0 13.5 29 L 15.5 29 A 1.50015 1.50015 0 1 0 15.5 26 L 13.5 26 z M 21.5 26 C 20.672 26 20 26.671 20 27.5 C 20 28.329 20.672 29 21.5 29 L 31.808594 29 L 34.779297 26.027344 C 34.688297 26.010344 34.596 26 34.5 26 L 21.5 26 z M 13.5 32 A 1.50015 1.50015 0 1 0 13.5 35 L 15.5 35 A 1.50015 1.50015 0 1 0 15.5 32 L 13.5 32 z M 21.5 32 C 20.672 32 20 32.671 20 33.5 C 20 34.329 20.672 35 21.5 35 L 25.808594 35 L 28.808594 32 L 21.5 32 z"/></svg></a></div><div class="cart-collateral"><span class="price">{PRICE}</span></div><div class="quantity"><input class="item-quantity" name="quantity" id="updates_{ID}" data-qtt-id="quantity_{ID}" value="{QUANTITY}" type="number" /></div></div><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><svg aria-hidden="true" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg></a></li>';
                    (n = (n = (n = (n = (n = (n = n.replace(/\{ID\}/g, e.items[i].id)).replace(/\{URL\}/g, e.items[i].url)).replace(/\{TITLE\}/g, m.translateText(e.items[i].product_title))).replace(
                        /\{VARIANT\}/g,
                        e.items[i].variant_title || ""
                    )).replace(/\{QUANTITY\}/g, e.items[i].quantity)).replace(/\{IMAGE\}/g, Shopify.resizeImage(e.items[i].image, "160x"))),
                        (n =
                            e.cart_level_discount_applications.length > 0
                                ? n.replace(/\{PRICE\}/g, Shopify.formatMoney(e.items[i].discounted_price, window.money_format))
                                : n.replace(/\{PRICE\}/g, Shopify.formatMoney(e.items[i].price, window.money_format))),
                        o.append(n);
                }
                t(".cart-sidebar-products").show(),
                    m.removeItemDropdownCart(e),
                    m.checkNeedToConvertCurrency() &&
                        (Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "#sidebar-cart span.money", "money_format"),
                        Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "#dropdown-cart span.money", "money_format"));
            } else t(".cart-sidebar-products").hide(), t(".wrapper-cartCount").hide();
            m.initFreeShippingMessage(), m.editCart(), m.checkItemsInDropdownCart();
        },
        translateText: function (t) {
            if (!window.multi_lang || t.indexOf("|") < 0) return t;
            if (window.multi_lang) {
                var e = t.split("|");
                return translator.isLang2() ? e[1] : e[0];
            }
        },
        checkNeedToConvertCurrency: function () {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        },
        loadJsonProductcard: function () {
            if (window.innerWidth > 1024)
                t(document)
                    .off("mouseover", ".product-item[data-product-id]")
                    .on("mouseover", ".product-item[data-product-id]", function (e) {
                        e.preventDefault();
                        var a = t(this);
                        if (!a[0].hasAttribute("data-json-product")) {
                            if (a.hasClass("json-loading")) return;
                            a.addClass("json-loading");
                            var o = a.find(".product-title").attr("href");
                            t.ajax({
                                type: "GET",
                                url: o,
                                data: { view: "get_json" },
                                cache: !1,
                                dataType: "html",
                                success: function (t) {
                                    var e = JSON.parse(t);
                                    a.attr("data-json-product", JSON.stringify(e));
                                },
                                complete: function () {
                                    a.removeClass("json-loading");
                                },
                            });
                        }
                    });
            else {
                t(window).scroll(function () {
                    t(".product-item[data-product-id]").each(function (e, a) {
                        var o, i, n, r;
                        t(this);
                        if (
                            ((o = t(a)),
                            (i = -100),
                            (n = o[0].getBoundingClientRect()),
                            (r = window.innerHeight || document.documentElement.clientHeight),
                            (i = i || 0),
                            n.bottom >= 0 - i / 1.5 && n.right >= 0 && n.top <= r + i && n.left <= (window.innerWidth || document.documentElement.clientWidth))
                        ) {
                            var s = t(this);
                            if (!s[0].hasAttribute("data-json-product")) {
                                if (s.hasClass("json-loading")) return;
                                s.addClass("json-loading");
                                var d = s.find(".product-title").attr("href");
                                t.ajax({
                                    type: "GET",
                                    url: d,
                                    data: { view: "get_json" },
                                    cache: !1,
                                    dataType: "html",
                                    success: function (t) {
                                        var e = JSON.parse(t);
                                        s.attr("data-json-product", JSON.stringify(e));
                                    },
                                    complete: function () {
                                        s.removeClass("json-loading");
                                    },
                                });
                            }
                        }
                    });
                });
            }
        },
        changeSwatchQs: function () {
            t(".selector-wrapper :radio").on("change", function (e) {
                var a,
                    o = t(this),
                    i = t(this).parents(".product-item"),
                    n = i.data("json-product"),
                    r = (n.id, n.variants),
                    s = i.find(".option-color").data("option-position"),
                    d = o.closest("[data-option-index]").data("option-index"),
                    l = i.find(".swatch-element"),
                    c = o.val(),
                    p = i.find("[name=id]"),
                    u = i.find(".selector-wrapper-1").find("input:checked").val(),
                    h = i.find(".selector-wrapper-2").find("input:checked").val();
                i.find(".selector-wrapper-3").find("input:checked").val();
                switch ((l.removeClass("soldout"), l.find(":radio").prop("disabled", !1), d)) {
                    case 0:
                        if (
                            null !=
                            (f = r.find(function (t) {
                                return 1 == s ? t.option2 == c && t.option1 == h : t.option1 == c && t.option2 == h;
                            }))
                        )
                            a = f;
                        else
                            a = r.find(function (t) {
                                return t.option1 == c;
                            });
                        break;
                    case 1:
                        null !=
                            (f = r.find(function (t) {
                                return 1 == s ? t.option2 == u && t.option1 == c : t.option1 == u && t.option2 == c;
                            })) && (a = f);
                        break;
                    case 2:
                        var f;
                        null !=
                            (f = r.find(function (t) {
                                return t.option1 == u && t.option2 == h && t.option3 == c;
                            })) && (a = f);
                }
                if (null != a) {
                    p.val(a.id);
                    var v = t(this).val();
                    a.compare_at_price > a.price ? i.find("[data-compare-price-grid]").html(Shopify.formatMoney(a.compare_at_price, window.money_format)) : i.find("[data-compare-price-grid]").html(""),
                        i.find("[data-price-grid]").html(Shopify.formatMoney(a.price, window.money_format)),
                        t(this).parents(".selector-wrapper").find(".form-label span").text(v),
                        m.checkStatusSwatchQs(i);
                }
            }),
                t(".product-card__variant--popup--content .single-option-selector").on("change", function () {
                    var e,
                        a = t(this),
                        o = t(this).parents(".product-item"),
                        i = o.data("json-product"),
                        n = (i.id, i.variants),
                        r = (o.find(".option-color").data("option-position"), a.data("option")),
                        s = (o.find(".swatch-element"), a.val()),
                        d = o.find("[name=id]"),
                        l = o.find('[data-option="option1"]').val(),
                        c = o.find('[data-option="option2"]').val();
                    o.find('[data-option="option3"]').val();
                    switch (r) {
                        case "option1":
                            if (
                                null !=
                                (p = n.find(function (t) {
                                    return t.option1 == s && t.option2 == c && t.available;
                                }))
                            )
                                e = p;
                            else
                                e = n.find(function (t) {
                                    return t.option1 == s && t.available;
                                });
                            break;
                        case "option2":
                            null !=
                                (p = n.find(function (t) {
                                    return t.option1 == l && t.option2 == s && t.available;
                                })) && (e = p);
                            break;
                        case "option3":
                            var p;
                            null !=
                                (p = n.find(function (t) {
                                    return t.option1 == l && t.option2 == c && t.option3 == s && t.available;
                                })) && (e = p);
                    }
                    null != e && d.val(e.id);
                    var u = t(this).val();
                    t(this).parents(".selector-wrapper").find(".form-label span").text(u), m.checkStatusSwatchQs(o);
                });
        },
        checkStatusSwatchQs: function (e) {
            if (window.use_color_swatch) {
                var a = e.data("json-product").variants,
                    o = e.find("[data-option-index]"),
                    i = e.find(".option-color").data("option-position"),
                    n = e.find('[data-option-index="0"]').find("input:checked").val(),
                    r = e.find('[data-option-index="1"]').find("input:checked").val();
                e.find('[data-option-index="2"]').find("input:checked").val();
                o.each(function () {
                    var o = t(this).data("option-index"),
                        s = t(this).find(".swatch-element");
                    switch (o) {
                        case 0:
                            s.each(function () {
                                var o = t(this).data("value"),
                                    n = a.find(function (t) {
                                        return 1 == i ? t.option2 == o && t.available : t.option1 == o && t.available;
                                    }),
                                    r = a.find(function (t) {
                                        return 1 == i ? t.option2 == o : t.option1 == o;
                                    });
                                null == n
                                    ? null == r
                                        ? (t(this).addClass("unavailable"), t(this).removeClass("soldout"), t(this).find(":radio").prop("checked", !1))
                                        : (t(this).addClass("soldout"), t(this).removeClass("unavailable"), t(this).find(":radio").prop("disabled", !1), e.find("[data-btn-addtocart]").addClass("unavailable").attr("disable"))
                                    : (t(this).removeClass("soldout"), t(this).removeClass("unavailable"), t(this).find(":radio").prop("disabled", !1), e.find("[data-btn-addtocart]").removeClass("unavailable").removeAttr("disable"));
                            });
                            break;
                        case 1:
                            s.each(function () {
                                var o = t(this).data("value"),
                                    r = a.find(function (t) {
                                        return 1 == i ? t.option2 == n && t.option1 == o && t.available : t.option1 == n && t.option2 == o && t.available;
                                    }),
                                    s = a.find(function (t) {
                                        return 1 == i ? t.option2 == n && t.option1 == o : t.option1 == n && t.option2 == o;
                                    });
                                null == r
                                    ? null == s
                                        ? (t(this).addClass("unavailable"), t(this).removeClass("soldout"), t(this).find(":radio").prop("checked", !1))
                                        : (t(this).addClass("soldout"), t(this).removeClass("unavailable"), t(this).find(":radio").prop("disabled", !1), e.find("[data-btn-addtocart]").addClass("unavailable").attr("disable"))
                                    : (t(this).removeClass("soldout"), t(this).removeClass("unavailable"), t(this).find(":radio").prop("disabled", !1), e.find("[data-btn-addtocart]").removeClass("unavailable").removeAttr("disable"));
                            });
                            break;
                        case 2:
                            s.each(function () {
                                var o = t(this).data("value"),
                                    i = a.find(function (t) {
                                        return t.option1 == n && t.option2 == r && t.option3 == o && t.available;
                                    }),
                                    s = a.find(function (t) {
                                        return t.option1 == n && t.option2 == r && t.option3 == o;
                                    });
                                null == i
                                    ? null == s
                                        ? (t(this).addClass("unavailable"), t(this).removeClass("soldout"), t(this).find(":radio").prop("checked", !1))
                                        : (t(this).addClass("soldout"), t(this).removeClass("unavailable"), t(this).find(":radio").prop("disabled", !1), e.find("[data-btn-addtocart]").addClass("unavailable").attr("disable"))
                                    : (t(this).removeClass("soldout"), t(this).removeClass("unavailable"), t(this).find(":radio").prop("disabled", !1), e.find("[data-btn-addtocart]").removeClass("unavailable").removeAttr("disable"));
                            });
                    }
                }),
                    e.find(".swatch-element.soldout").find("input:checked").length ? e.find("[data-btn-addtocart]").addClass("disabled").attr("disabled", !0) : e.find("[data-btn-addtocart]").removeClass("disabled").removeAttr("disabled");
            } else {
                (a = e.data("json-product").variants),
                    (o = e.find(".product-card__variant--popup--content [data-option]")),
                    (i = e.find(".option-color").data("option-position")),
                    (n = e.find('.product-card__variant--popup--content [data-option="option1"]').val()),
                    (r = e.find('.product-card__variant--popup--content [data-option="option2"]').val()),
                    e.find('.product-card__variant--popup--content [data-option="option3"]').val();
                o.each(function () {
                    var e = t(this).data("option-index"),
                        o = t(this).find("option");
                    switch (e) {
                        case 0:
                            o.each(function () {
                                var e = t(this).val();
                                null ==
                                a.find(function (t) {
                                    return t.option1 == e && t.available;
                                })
                                    ? null ==
                                      a.find(function (t) {
                                          return t.option1 == e;
                                      })
                                        ? (t(this).addClass("unavailable"), t(this).removeClass("soldOut"), t(this).attr("disabled", "disabled"))
                                        : (t(this).addClass("soldOut"), t(this).removeClass("unavailable"), t(this).removeAttr("disabled", "disabled"))
                                    : (t(this).removeAttr("disabled", "disabled"), t(this).removeClass("soldOut"), t(this).removeClass("unavailable"));
                            });
                            break;
                        case 1:
                            o.each(function () {
                                var e = t(this).val();
                                null ==
                                a.find(function (t) {
                                    return t.option1 == n && t.option2 == e && t.available;
                                })
                                    ? null ==
                                      a.find(function (t) {
                                          return t.option1 == n && t.option2 == e;
                                      })
                                        ? (t(this).addClass("unavailable"), t(this).removeClass("soldOut"), t(this).attr("disabled", "disabled"))
                                        : (t(this).addClass("soldOut"), t(this).removeClass("unavailable"), t(this).removeAttr("disabled", "disabled"))
                                    : (t(this).removeAttr("disabled", "disabled"), t(this).removeClass("soldOut"), t(this).removeClass("unavailable"));
                            });
                            break;
                        case 2:
                            o.each(function () {
                                var e = t(this).val();
                                null ==
                                a.find(function (t) {
                                    return t.option1 == n && t.option2 == r && t.option3 == e && t.available;
                                })
                                    ? null ==
                                      a.find(function (t) {
                                          return t.option1 == n && t.option2 == r && t.option3 == e;
                                      })
                                        ? (t(this).addClass("unavailable"), t(this).removeClass("soldOut"), t(this).attr("disabled", "disabled"))
                                        : (t(this).addClass("soldOut"), t(this).removeClass("unavailable"), t(this).removeAttr("disabled", "disabled"))
                                    : (t(this).removeAttr("disabled", "disabled"), t(this).removeClass("soldOut"), t(this).removeClass("unavailable"));
                            });
                    }
                }),
                    e.find(".product-card__variant--popup--content .single-option-selector").find("option.soldOut:selected").length
                        ? e.find("[data-btn-addtocart]").addClass("disabled").attr("disabled", !0)
                        : e.find("[data-btn-addtocart]").removeClass("disabled").removeAttr("disabled");
            }
        },
        initQuickshop: function () {
            i.off("click.quickshop").on("click.quickshop", "[data-init-quickshop]", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this);
                productItem = a.parents(".product-item");
                productItem.find(".option-color");
                a.parents(".action").addClass("show-popup-qs"), m.changeSwatchQs();
                productItem.data("json-product");
                m.checkStatusSwatchQs(productItem),
                    a
                        .parents(".action")
                        .find(".selector-wrapper:not(.option-color)")
                        .each(function () {
                            t(this).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find("label").trigger("click");
                        });
            }),
                i.off("click.cancelquickshop").on("click.cancelquickshop", "[data-cancel-swatch-qs]", function () {
                    t(this).parents(".action").removeClass("show-popup-qs");
                });
        },
        initColorSwatchGrid: function () {
            i.off("click.toggleClass").on("click.toggleClass", ".item-swatch li label", function () {
                t(this).parents(".inner-top").find(".action").removeClass("show-popup-qs");
                var e = t(this),
                    a = e.attr("title").replace(/^\s+|\s+$/g, ""),
                    o = e.closest(".grid-item"),
                    i = o.closest(".sidebar-widget-product");
                e.parents(".item-swatch").find("li label").removeClass("active"), e.addClass("active");
                var n = t(this).parents(".product-item").data("json-product"),
                    r = [];
                if (
                    (o.find(".product-title").hasClass("change-text")
                        ? o
                              .find(".product-title")
                              .find("[data-change-title]")
                              .text(" - " + a)
                        : o
                              .find(".product-title")
                              .addClass("change-text")
                              .append("<span data-change-title> - " + a + "</span>"),
                    null != e.data("with-one-option"))
                ) {
                    var s = e.data("quantity");
                    o.find('[name="id"]').val(e.data("with-one-option")),
                        s > 0 ? o.find("[data-btn-addtocart]").removeClass("disabled").removeAttr("disabled") : o.find("[data-btn-addtocart]").addClass("disabled").attr("disabled", "disabled");
                } else
                    null != n && m.checkStatusSwatchQs(t(this).parents(".product-item")),
                        o
                            .find('[data-value="' + a + '"]')
                            .find("label")
                            .trigger("click");
                if (null != n)
                    r = n.media.filter(function (t) {
                        return t.alt === a;
                    });
                if (r.length > 0 && "variant_grouped" == window.color_swatch_style) {
                    if (r.length > 1) var d = 2;
                    else d = r.length;
                    for (var l = 0; l < d; l++) o.find('picture[data-index="' + l + '"] > *').attr("srcset", r[l].src);
                } else {
                    var c = e.data("img");
                    if ((i.length && (c = c.replace("800x", "large")), c)) return o.find(".product-grid-image > picture > *, .product-grid-image > img").attr({ srcset: c }), !1;
                }
            }),
                i.off("click.showmore").on("click.showmore", ".item-swatch-more a", function () {
                    t(this).parents(".item-swatch").toggleClass("show--more"), t(this).parents(".item-swatch").hasClass("show--more") ? t(this).children().text("-") : t(this).children().text("+");
                });
        },
        showLoading: function () {
            t(".loading-modal").show();
        },
        hideLoading: function () {
            t(".loading-modal").hide();
        },
        showModal: function (e) {
            t(e).fadeIn(500),
                (m.ellaTimeout = setTimeout(function () {
                    t(e).fadeOut(500);
                }, 5e3));
        },
        translateBlock: function (t) {
            window.multi_lang && translator.isLang2() && translator.doTranslate(t);
        },
        closeLookbookModal: function () {
            t(".ajax-lookbook-modal").fadeOut(500);
        },
        addEventLookbookModal: function () {
            i.off("click.addEvenLookbookModal touchstart.addEvenLookbookModal", "[data-lookbook-icon]").on("click.addEvenLookbookModal touchstart.addEvenLookbookModal", "[data-lookbook-icon]", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this).data("handle"),
                    o = t(this);
                m.doAjaxAddLookbookModal(a, o),
                    n.off("click.closeLookbookModal").on("click.closeLookbookModal", "[data-close-lookbook-modal], .ajax-lookbook-modal .overlay", function () {
                        return m.closeLookbookModal(), !1;
                    });
            });
        },
        doAjaxAddLookbookModal: function (e, a) {
            var o,
                i,
                n = t(a).offset(),
                r = n.top,
                s = n.left,
                d = a.innerWidth(),
                l = t(".ajax-lookbook-modal").innerWidth(),
                c = d + "px",
                p = l + "px";
            window.innerWidth > 767 ? ((i = s > l + 31 ? "calc(" + s + "px - " + p + " + 2px)" : "calc(" + s + "px + " + c + " - 2px)"), (o = r - l / 2 + "px")) : ((i = 0), (o = r - 30 + "px")),
                m.isAjaxLoading ||
                    t.ajax({
                        type: "get",
                        url: window.router + "/products/" + e + "?view=json",
                        success: function (e) {
                            t(".ajax-lookbook-modal").css({ left: i, top: o }), t(".ajax-lookbook-modal .lookbook-content").html(e), m.translateBlock(".lookbook-content"), t(".ajax-lookbook-modal").fadeIn(500);
                        },
                        error: function (e, a) {
                            t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.showModal(".ajax-error-modal");
                        },
                    });
        },
        clickedActiveProductTabs: function () {
            t("[data-home-product-tabs]").each(function () {
                var e = t(this),
                    a = e.find(".list-product-tabs").find("[data-product-tabTop]"),
                    o = e.find("[data-product-TabContent]"),
                    i = e.find(".list-product-tabs .tab-links.active"),
                    n = e.find(".product-tabs-content .tab-content.active");
                m.doAjaxProductTabs(i.data("href"), n.find(".loading"), n.find(".products-grid")),
                    a.off("click").on("click", function (e) {
                        if ((e.preventDefault(), e.stopPropagation(), !t(this).hasClass("active") && !t(this).hasClass("active"))) {
                            var i = t(this),
                                n = t(i.data("target"));
                            a.removeClass("active"),
                                o.removeClass("active"),
                                n.find(".products-grid").hasClass("slick-initialized") || m.doAjaxProductTabs(i.data("href"), n.find(".loading"), n.find(".products-grid")),
                                i.addClass("active"),
                                n.addClass("active");
                        }
                    });
            });
        },
        doAjaxProductTabs: function (e, a, o) {
            t.ajax({
                type: "get",
                url: e,
                beforeSend: function () {
                    a.text("Loading ... please wait ...");
                },
                success: function (i) {
                    a.hide(),
                        "/collections/?view=json" == e
                            ? a.text("Please link to collections").show()
                            : (o.html(t(i).find(".grid-items").html()),
                              o.hasClass("slick-initialized") || m.initProductTabsSlider(o.parent()),
                              m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                              m.translateBlock("[data-home-product-tabs]"),
                              m.initColorSwatchGrid(),
                              m.initWishListIcons(),
                              (m.ellaTimeout = setTimeout(function () {
                                  if (t(".shopify-product-reviews-badge").length && t(".spr-badge").length)
                                      return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                              }, 1e3)));
                },
                error: function (t, e) {
                    a.text("Sorry, there are no products in this collection").show();
                },
            });
        },
        initProductTabsSlider: function (e) {
            e.each(function () {
                var e = t(this),
                    a = e.find(".products-grid"),
                    o = a.data("row");
                a.not(".slick-initialized") &&
                    a.find(".grid-item").length &&
                    a.slick({
                        slidesToShow: a.data("row"),
                        slidesToScroll: a.data("row"),
                        dots: !1,
                        infinite: !1,
                        speed: 1e3,
                        get nextArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.nextArrow =
                                      '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>');
                        },
                        get prevArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.prevArrow =
                                      '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>');
                        },
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    dots: !0,
                                    arrows: !1,
                                    get slidesToShow() {
                                        return e.hasClass("sections-has-banner") ? (this.slidesToShow = 2) : o >= 4 ? (this.slidesToShow = 4) : (o = 3) ? (this.slidesToShow = 3) : (this.slidesToShow = 2);
                                    },
                                    get slidesToScroll() {
                                        return e.hasClass("sections-has-banner") ? (this.slidesToScroll = 2) : o >= 4 ? (this.slidesToScroll = 4) : (o = 3) ? (this.slidesToScroll = 3) : (this.slidesToScroll = 2);
                                    },
                                },
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    dots: !0,
                                    arrows: !1,
                                    get slidesToShow() {
                                        return e.hasClass("sections-has-banner") ? (this.slidesToShow = 2) : o >= 3 ? (this.slidesToShow = 3) : void (this.slidesToShow = 2);
                                    },
                                    get slidesToScroll() {
                                        return e.hasClass("sections-has-banner") ? (this.slidesToScroll = 2) : (this.slidesToScroll = o >= 3 ? 3 : 2);
                                    },
                                },
                            },
                            { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2, arrows: !1, dots: !0 } },
                        ],
                    });
            });
        },
        initProductReview: function () {
            setInterval(function () {
                if (!t(".spr-reviews").hasClass("slick-initialized") && t(".product-template-skin-1").length) {
                    if (!t(".spr-reviews").find(".spr-review").length) return;
                    var e = t(".spr-reviews");
                    e.slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: !0,
                        arrows: !1,
                        infinite: !0,
                        speed: 1e3,
                        centerMode: !0,
                        centerPadding: "20%",
                        responsive: [
                            { breakpoint: 1200, settings: { slidesToShow: 2 } },
                            { breakpoint: 992, settings: { slidesToShow: 1 } },
                            { breakpoint: 480, settings: { slidesToShow: 1, centerMode: !1 } },
                        ],
                    }),
                        e.find(".spr-review").each(function () {
                            t(this).find(".spr-review-header-byline").appendTo(t(this).find(".spr-review-footer"));
                        });
                }
            });
        },
        initCountdown: function () {
            t("[data-countdown]").each(function () {
                var e = t(this),
                    a = e.data("countdown-value");
                e.countdown(a, function (e) {
                    t(this).html(
                        e.strftime(
                            '<div class="clock-item"><span class="num">%D</span><span>' +
                                window.inventory_text.days +
                                '</span></div><div class="clock-item"><span class="num">%H</span><span>' +
                                window.inventory_text.hours +
                                '</span></div><div class="clock-item"><span class="num">%M</span><span>' +
                                window.inventory_text.mins +
                                '</span></div><div class="clock-item"><span class="num">%S</span><span>' +
                                window.inventory_text.secs +
                                "</span></div>"
                        )
                    );
                });
            });
        },
        initCountdownNormal: function () {
            t("[data-countdown-normal]").each(function () {
                var e = t(this),
                    a = e.data("countdown-value");
                e.hasClass("countdown-suppermarket")
                    ? e.countdown(a, function (e) {
                          t(this).html(
                              e.strftime(
                                  '<div class="clock-item"><span class="num">%D</span><span>d</span></div><div class="clock-item"><span class="num">%H</span>&nbsp;:</div><div class="clock-item"><span class="num">%M</span>&nbsp;:</div><div class="clock-item"><span class="num">%S</span></div>'
                              )
                          );
                      })
                    : e.countdown(a, function (e) {
                          t(this).html(
                              e.strftime(
                                  '<div class="clock-item"><span class="num">%D</span><span>D</span>:</div><div class="clock-item"><span class="num">%H</span><span>H</span>:</div><div class="clock-item"><span class="num">%M</span><span>M</span>:</div><div class="clock-item"><span class="num">%S</span><span>S</span></div>'
                              )
                          );
                      });
            });
        },
        initToggleSubMenuMobile: function () {
            var e = t(".main-menu.jas-mb-style");
            t(".site-nav")
                .find("[data-toggle-menu-mb]")
                .off("click.dropdownMenu")
                .on("click.dropdownMenu", function (a) {
                    a.preventDefault(), a.stopPropagation();
                    var o = t(this).parent().next(".sub-menu-mobile");
                    o.hasClass("sub-menu-open") ? o.removeClass("sub-menu-open") : (o.addClass("sub-menu-open").css({ overflow: "" }), e.animate({ scrollTop: 0 }, 0), e.css({ overflow: "hidden" }));
                }),
                m.linkClickToggleSubMenuMobile(e);
        },
        linkClickToggleSubMenuMobile: function (e) {
            var a = t(".site-nav .dropdown"),
                o = a.find("[data-toggle-menu-mb]"),
                i = t(".sub-menu-mobile .menu-mb-title");
            o.length &&
                o.is(":visible") &&
                (a.off("click.current").on("click.current", function (a) {
                    a.stopPropagation(), t(this).children(".sub-menu-mobile").addClass("sub-menu-open").css({ overflow: "" }), e.animate({ scrollTop: 0 }, 0), e.css({ overflow: "hidden" });
                }),
                a.find(".menu__moblie").on("click", function (t) {
                    t.stopPropagation();
                }),
                i.off("click.closeMenu").on("click.closeMenu", function (a) {
                    a.preventDefault(),
                        a.stopPropagation(),
                        t(this).parent().hasClass("bg") ? t(this).parent().parent().removeClass("sub-menu-open") : t(this).parent().removeClass("sub-menu-open"),
                        t(this).closest(".menu-lv-2").length || e.css({ overflow: "" });
                }));
        },
        openEmailModalWindow: function (t) {
            t.fadeIn(1e3);
        },
        closeEmailModalWindow: function (e, a) {
            e.fadeOut(1e3), (!e.find('input[name="dismiss"]').prop("checked") && e.find('input[name="dismiss"]').length) || t.cookie("emailSubcribeModal", "closed", { expires: a, path: "/" });
        },
        initNewsLetterPopup: function () {
            if (window.newsletter_popup) {
                var e = t("[data-newsletter]"),
                    a = e.find(".close-window"),
                    o = e.data("delay"),
                    i = e.data("expire"),
                    n = e.find(".halo-modal-content");
                "closed" != t.cookie("emailSubcribeModal") &&
                    0 == window.hidden_newsletter &&
                    (m.ellaTimeout = setTimeout(function () {
                        m.openEmailModalWindow(e);
                    }, o)),
                    t("[data-toolbar-newsletter]").length &&
                        t("[data-modal-newsletter]").on("click", function () {
                            m.openEmailModalWindow(e);
                        }),
                    a.click(function (t) {
                        t.preventDefault(), m.closeEmailModalWindow(e, i);
                    }),
                    e.on("click", function (t) {
                        n.is(t.target) || n.has(t.target).length || m.closeEmailModalWindow(e, i);
                    }),
                    t("#mc_embed_signup form").submit(function () {
                        "" != t("#mc_embed_signup .email").val() && m.closeEmailModalWindow(e, i);
                    });
            }
        },
        initSidebarProductSlider: function () {
            t("[data-sidebar-product]").each(function () {
                var e = t(this).find(".products-grid");
                e.not(".slick-initialized") &&
                    e.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: !1,
                        speed: 800,
                        get dots() {
                            return "layout_style_1170" == window.layout_style ? (this.dots = !0) : (this.dots = !1);
                        },
                        get nextArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.nextArrow =
                                      '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>');
                        },
                        get prevArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.prevArrow =
                                      '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>');
                        },
                    });
            });
        },
        initOpenSidebar: function () {
            t(".sidebar-label").length &&
                i.off("click.openSidebar").on("click.openSidebar", ".sidebar-label", function () {
                    r.addClass("sidebar-open");
                });
        },
        closeSidebar: function () {
            m.closeTranslate(".sidebar .close-sidebar", "sidebar-open");
        },
        initSidebar: function () {
            this.initSidebarProductSlider(), this.initOpenSidebar(), this.closeSidebar(), this.initDropdownSubCategoriesAtSidebar(), this.initToggleWidgetTitleSidebarFilter();
        },
        initDropdownSubCategoriesAtSidebar: function () {
            i.off("click.toggleSubCategories").on("click.toggleSubCategories", ".sidebar-links li.dropdown", function (e) {
                e.stopPropagation();
                var a = t(this),
                    o = a.find("> .dropdown-cat");
                a.hasClass("open") ? (a.removeClass("open"), o.slideUp()) : (a.addClass("open"), o.slideDown());
            }),
                i.off("click.linktoCollection").on("click.linktoCollection", ".sidebar-links li.dropdown a", function (t) {
                    t.stopPropagation();
                });
        },
        historyAdapter: function () {
            t('[data-section-type="collection-template"]').length &&
                History.Adapter.bind(window, "statechange", function () {
                    History.getState();
                    if (!m.isSidebarAjaxClick) {
                        m.queryParams();
                        var t = m.ajaxCreateUrl();
                        m.doAjaxToolbarGetContent(t), m.doAjaxSidebarGetContent(t);
                    }
                    m.isSidebarAjaxClick = !1;
                });
        },
        queryParams: function () {
            if (((Shopify.queryParams = {}), location.search.length))
                for (var t, e = 0, a = location.search.substr(1).split("&"); e < a.length; e++) (t = a[e].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(t[0])] = decodeURIComponent(t[1]));
        },
        filterAjaxClick: function (t) {
            delete Shopify.queryParams.page;
            var e = m.ajaxCreateUrl(t);
            (m.isSidebarAjaxClick = !0), History.pushState({ param: Shopify.queryParams }, e, e);
        },
        ajaxCreateUrl: function (e) {
            var a = t.param(Shopify.queryParams).replace(/%2B/g, "+");
            return e ? ("" != a ? e + "?" + a : e) : location.pathname + "?" + a;
        },
        filterToolbar: function () {
            this.queryParams(), this.setTextForSortbyFilter(), this.setTextForLimitedFilter(), this.ajaxFilterSortby(), this.ajaxFilterLimit(), this.addEventViewModeLayout();
        },
        setTextForSortbyFilter: function () {
            var e = t("[data-sortby]"),
                a = e.find(".label-tab"),
                o = a.find(".label-text"),
                i = a.next().find("li.active").text();
            if ((o.text(i), Shopify.queryParams.sort_by)) {
                var n = Shopify.queryParams.sort_by,
                    r = e.find('span[data-href="' + n + '"]'),
                    s = r.text();
                o.text(s), a.next().find("li").removeClass("active"), r.parent().addClass("active");
            }
        },
        setTextForLimitedFilter: function () {
            var e = t("[data-limited-view]"),
                a = e.find(".label-tab"),
                o = a.find(".label-text"),
                i = a.next().find("li.active").text();
            if ((o.text(i), e.length)) {
                var n = e.find("li.active span").data("value"),
                    r = e.find('span[data-value="' + n + '"]'),
                    s = r.text();
                o.text(s), a.next().find("li").removeClass("active"), r.parent().addClass("active");
            }
        },
        ajaxFilterSortby: function () {
            var e = t("[data-sortby] li span");
            i.off("click.sortBy", "[data-sortby] li span").on("click.sortBy", "[data-sortby] li span", function (a) {
                if ((a.preventDefault(), a.stopPropagation(), !t(this).parent().hasClass("active"))) {
                    (Shopify.queryParams.sort_by = t(this).attr("data-href")), m.filterAjaxClick();
                    var o = m.ajaxCreateUrl();
                    m.doAjaxToolbarGetContent(o);
                }
                e.closest(".dropdown-menu").prev().trigger("click");
            });
        },
        ajaxFilterLimit: function () {
            var e = t("[data-limited-view] li span");
            i.off("click.sortBy", "[data-limited-view] li span").on("click.sortBy", "[data-limited-view] li span", function (a) {
                a.preventDefault(), a.stopPropagation();
                var o = t(this);
                if (!o.parent().hasClass("active")) {
                    var i = "" + o.data("value");
                    t("[data-limited-view] .label-tab .label-text").text(i), m.doAjaxLimitGetContent(i);
                }
                e.closest(".dropdown-menu").prev().trigger("click");
            });
        },
        doAjaxLimitGetContent: function (e) {
            m.isAjaxLoading ||
                t.ajax({
                    type: "Post",
                    url: "/cart.js",
                    data: { "attributes[pagination]": e },
                    success: function (t) {
                        window.location.reload();
                    },
                    error: function (e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.showModal(".ajax-error-modal");
                    },
                    dataType: "json",
                });
        },
        doAjaxToolbarGetContent: function (e) {
            m.isAjaxLoading ||
                t.ajax({
                    type: "get",
                    url: e,
                    beforeSend: function () {
                        m.showLoading();
                    },
                    success: function (t) {
                        m.ajaxMapData(t), m.initColorSwatchGrid(), m.setTextForSortbyFilter(), m.initSidebarProductSlider(), m.initCountdownNormal();
                    },
                    error: function (e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.showModal(".ajax-error-modal");
                    },
                    complete: function () {
                        m.hideLoading();
                    },
                });
        },
        filterSidebar: function () {
            this.queryParams(), this.ajaxFilterTags(), this.ajaxFilterClearTags(), this.ajaxFilterClearAll();
        },
        ajaxFilterTags: function () {
            i.off("click.filterTags").on("click.filterTags", ".sidebar-tags .list-tags a, .sidebar-tags .list-tags label, .refined .selected-tag", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = [];
                if ((Shopify.queryParams.constraint && (a = Shopify.queryParams.constraint.split("+")), !window.enable_sidebar_multiple_choice && !t(this).prev().is(":checked"))) {
                    var o,
                        i,
                        n = t(this).closest(".sidebar-tags, .refined-widgets").find("input:checked");
                    if (n.length) if ((o = n.val())) (i = a.indexOf(o)) >= 0 && a.splice(i, 1);
                }
                (o = t(this).prev().val()) && ((i = a.indexOf(o)) >= 0 ? a.splice(i, 1) : a.push(o));
                a.length ? (Shopify.queryParams.constraint = a.join("+")) : delete Shopify.queryParams.constraint, m.filterAjaxClick();
                var r = m.ajaxCreateUrl();
                m.doAjaxSidebarGetContent(r);
            });
        },
        ajaxFilterClearTags: function () {
            t(".sidebar-tags").each(function () {
                var e = t(this);
                e.find("input:checked").length &&
                    e
                        .find(".clear")
                        .show()
                        .click(function (a) {
                            a.preventDefault(), a.stopPropagation();
                            var o = [];
                            Shopify.queryParams.constraint && (o = Shopify.queryParams.constraint.split("+")),
                                e.find("input:checked").each(function () {
                                    var e = t(this).val();
                                    if (e) {
                                        var a = o.indexOf(e);
                                        a >= 0 && o.splice(a, 1);
                                    }
                                }),
                                o.length ? (Shopify.queryParams.constraint = o.join("+")) : delete Shopify.queryParams.constraint,
                                m.filterAjaxClick();
                            var i = m.ajaxCreateUrl();
                            m.doAjaxSidebarGetContent(i);
                        });
            });
        },
        ajaxFilterClearAll: function () {
            var e = ".refined-widgets a.clear-all";
            t(e);
            i.off("click.clearAllTags", e).on("click.clearAllTags", e, function (t) {
                t.preventDefault(), t.stopPropagation(), delete Shopify.queryParams.constraint, m.filterAjaxClick();
                var e = m.ajaxCreateUrl();
                m.doAjaxSidebarGetContent(e);
            });
        },
        doAjaxSidebarGetContent: function (e) {
            m.isAjaxLoading ||
                t.ajax({
                    type: "get",
                    url: e,
                    beforeSend: function () {
                        m.showLoading();
                    },
                    success: function (t) {
                        m.ajaxMapData(t), m.initColorSwatchGrid(), m.ajaxFilterClearTags(), m.initSidebarProductSlider(), m.initCountdownNormal();
                    },
                    error: function (e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.showModal(".ajax-error-modal");
                    },
                    complete: function () {
                        m.hideLoading();
                    },
                });
        },
        ajaxMapData: function (e) {
            var a = t(".collection-template"),
                o = a.find(".breadcrumb"),
                i = a.find(".sidebar"),
                n = a.find(".collection-header"),
                r = a.find(".product-collection"),
                s = a.find(".padding"),
                d = t(e).find(".collection-template"),
                l = d.find(".breadcrumb"),
                c = d.find(".sidebar"),
                p = d.find(".collection-header"),
                u = d.find(".product-collection"),
                h = d.find(".padding");
            if (
                (o.replaceWith(l),
                i.replaceWith(c),
                n.replaceWith(p),
                r.replaceWith(u),
                s.length > 0 ? s.replaceWith(h) : a.find(".col-main").length ? a.find(".col-main").append(h) : a.find(".col-no-sidebar").append(h),
                m.translateBlock(".collection-template"),
                m.hide_filter(),
                m.initWishListIcons(),
                t("[data-view-as]").length && m.viewModeLayout(),
                m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                t(".shopify-product-reviews-badge").length && t(".spr-badge").length)
            )
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
        },
        initToggleWidgetTitleSidebarFilter: function () {
            i.off("click.toggleWidgetContent").on("click.toggleWidgetContent", "[data-has-collapse] .widget-title", function () {
                t(this).toggleClass("open"), t(this).next().slideToggle();
            });
            var e = t(".toolbar");
            if (s.innerWidth() < 1200) {
                i.off("click.toggleWidgetContent2").on("click.toggleWidgetContent2", "[data-has-collapse-no-sidebar] .widget-title", function () {
                    t(this).toggleClass("open"), t(this).next().slideToggle();
                }),
                    s.innerWidth() < 992 ? t(".filters-toolbar__sortby").insertAfter(".column-left .sidebar-label") : t(".filters-toolbar__sortby").appendTo(".toolbar .column-right");
                var a = e.outerHeight() + 30,
                    o = e.offset().top;
                t(window).scroll(function () {
                    var i = t(".sticky-wrapper.is-sticky").outerHeight();
                    t(this).scrollTop() > o
                        ? (t('[data-section-type="collection-template"]').css("padding-top", a), e.addClass("toolbar-fix"), e.css("top", i))
                        : (t('[data-section-type="collection-template"]').css("padding-top", 0), e.removeClass("toolbar-fix"), e.css("top", 0));
                });
            } else
                t(".filters-toolbar__sortby").appendTo(".toolbar .column-right"),
                    t('[data-section-type="collection-template"]').css("padding-top", 0),
                    e.removeClass("toolbar-fix"),
                    e.css("top", 0),
                    t(".collection-template-skin-1").length &&
                        (t(".toolbar").appendTo(".appendTo-toolbar .container"),
                        i.off("click.toggleSidebar").on("click.toggleSidebar", ".sidebar-label-desktop", function () {
                            t(this).parents(".halo-collection-content").toggleClass("remove-sidebar");
                        }));
            s.resize(function () {
                if (s.innerWidth() < 1200) {
                    i.off("click.toggleWidgetContent2").on("click.toggleWidgetContent2", "[data-has-collapse-no-sidebar] .widget-title", function () {
                        t(this).toggleClass("open"), t(this).next().slideToggle();
                    }),
                        s.innerWidth() < 992 ? t(".filters-toolbar__sortby").insertAfter(".column-left .sidebar-label") : t(".filters-toolbar__sortby").appendTo(".toolbar .column-right");
                    var a = e.outerHeight() + 30,
                        o = e.offset().top;
                    t(window).scroll(function () {
                        var i = t(".sticky-wrapper.is-sticky").outerHeight();
                        t(this).scrollTop() > o
                            ? (t('[data-section-type="collection-template"]').css("padding-top", a), e.addClass("toolbar-fix"), e.css("top", i))
                            : (t('[data-section-type="collection-template"]').css("padding-top", 0), e.removeClass("toolbar-fix"), e.css("top", 0));
                    });
                } else
                    t(".filters-toolbar__sortby").appendTo(".toolbar .column-right"),
                        t('[data-section-type="collection-template"]').css("padding-top", 0),
                        e.removeClass("toolbar-fix"),
                        e.css("top", 0),
                        t(window).scroll(function () {
                            e.removeClass("toolbar-fix");
                        }),
                        t(".collection-template-skin-1").length &&
                            (t(".toolbar").appendTo(".appendTo-toolbar .container"),
                            i.off("click.toggleSidebar").on("click.toggleSidebar", ".sidebar-label-desktop", function () {
                                t(this).parents(".halo-collection-content").toggleClass("remove-sidebar");
                            }));
            }),
                i.off("click.viewMoreFilter").on("click.viewMoreFilter", "[data-list-filter]", function () {
                    var e = t(this).parents(".list-tags").find(".last");
                    t(this).parents(".list-tags").hasClass("show-all") ? (e.hide(), t(this).text(window.inventory_text.view_more)) : (e.show(), t(this).text(window.inventory_text.view_less)),
                        t(this).parents(".list-tags").toggleClass("show-all");
                });
        },
        initInfiniteScrolling: function () {
            var e = t(".infinite-scrolling");
            e.length &&
                (i.off("click.initInfiniteScrolling", ".infinite-scrolling a").on("click.initInfiniteScrolling", ".infinite-scrolling a", function (e) {
                    if ((e.preventDefault(), e.stopPropagation(), !t(this).hasClass("disabled"))) {
                        var a = t(this).data("href");
                        m.doAjaxInfiniteScrollingGetContent(a);
                    }
                }),
                window.infinity_scroll_feature &&
                    t(window).scroll(function () {
                        if (!m.isAjaxLoading) {
                            var e = t('[data-section-type="collection-template"]');
                            e.length || (e = t("[data-search-page]"));
                            var a = e.offset().top + e.outerHeight() - t(window).height();
                            if (t(this).scrollTop() > a && t(this).scrollTop() < a + 200) {
                                var o = t(".infinite-scrolling a");
                                if (o.length && !o.hasClass("disabled")) {
                                    var i = o.data("href");
                                    m.doAjaxInfiniteScrollingGetContent(i);
                                }
                            }
                        }
                    }));
        },
        doAjaxInfiniteScrollingGetContent: function (e) {
            m.isAjaxLoading ||
                t.ajax({
                    type: "get",
                    url: e,
                    beforeSend: function () {
                        m.showLoading();
                    },
                    success: function (e) {
                        m.ajaxInfiniteScrollingMapData(e), m.initColorSwatchGrid(), t("[data-view-as]").length && m.viewModeLayout(), m.initCountdownNormal();
                    },
                    error: function (e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.showModal(".ajax-error-modal");
                    },
                    complete: function () {
                        m.hideLoading();
                    },
                });
        },
        ajaxInfiniteScrollingMapData: function (e) {
            var a = t(".collection-template"),
                o = a.find(".product-collection"),
                i = a.find(".padding"),
                n = t(e).find(".collection-template"),
                r = n.find(".product-collection"),
                s = n.find(".padding"),
                d = r.children(".grid-item").not(".banner-img");
            t(".infinite-scrolling a");
            if (
                (i.replaceWith(s),
                r.length &&
                    (o.append(d),
                    t(".collection-template .product-collection[data-layout]").length &&
                        (m.ellaTimeout = setTimeout(function () {
                            o.isotope("appended", d).isotope("layout");
                        }, 700)),
                    m.translateBlock(".product-collection"),
                    m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                    t(".shopify-product-reviews-badge").length && t(".spr-badge").length))
            )
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
        },
        addEventViewModeLayout: function () {
            m.setActiveViewModeMediaQuery(),
                i.on("click", ".view-mode .icon-mode", function (e) {
                    e.preventDefault();
                    var a = t(this),
                        o = (a.data("col"), a.closest("[data-view-as]"));
                    a.hasClass("active") ||
                        (o.find(".icon-mode").removeClass("active"),
                        a.addClass("active"),
                        m.viewModeLayout(),
                        window.innerWidth > 767 && t(".product-collection").find("img").removeClass("lazyautosizes ls-is-cached lazyloaded").addClass("lazyload"));
                });
        },
        viewModeLayout: function () {
            var e = t("[data-view-as]").find(".icon-mode.active").data("col"),
                a = t(".collection-template .product-collection"),
                o = a.find(".grid-item"),
                i = "col-12 col-6 col-md-4 col-lg-3 col5",
                n = "grid-2 grid-3 grid-4 grid-5 products-grid products-list";
            switch (e) {
                case 1:
                    o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-list") : a.removeClass("products-grid").addClass("products-list"), o.removeClass(i).addClass("col-12");
                    break;
                default:
                    switch (e) {
                        case 2:
                            o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-grid grid-2") : a.removeClass("products-list").addClass("products-grid"), o.removeClass(i).addClass("col-6");
                            break;
                        case 3:
                            o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-grid grid-3") : a.removeClass("products-list").addClass("products-grid"), o.removeClass(i).addClass("col-6 col-md-4");
                            break;
                        case 4:
                            o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-grid grid-4") : a.removeClass("products-list").addClass("products-grid"), o.removeClass(i).addClass("col-6 col-md-4 col-lg-3");
                            break;
                        case 5:
                            o.hasClass("grid-item-mansory") ? a.removeClass(n).addClass("products-grid grid-5") : a.removeClass("products-list").addClass("products-grid"), o.removeClass(i).addClass("col-6 col-md-4 col-lg-3 col5");
                    }
            }
        },
        setActiveViewModeMediaQuery: function () {
            var e = t("[data-view-as]"),
                a = e.find(".icon-mode.active"),
                o = a.data("col"),
                i = window.innerWidth;
            i < 768
                ? (3 !== o && 4 != o && 5 != o) || (a.removeClass("active"), t('[data-col="2"]').addClass("active"))
                : i < 992 && i >= 768
                ? (4 != o && 5 != o) || (a.removeClass("active"), t('[data-col="3"]').addClass("active"))
                : i < 1200 && i >= 992 && 5 == o && (a.removeClass("active"), t('[data-col="4"]').addClass("active")),
                e.length && m.viewModeLayout();
        },
        initPaginationPage: function () {
            i.off("click", ".pagination-page a").on("click", ".pagination-page a", function (e) {
                if (Shopify.queryParams) {
                    e.preventDefault();
                    var a = t(this)
                        .attr("href")
                        .match(/page=\d+/g);
                    if (a && ((Shopify.queryParams.page = parseInt(a[0].match(/\d+/g))), Shopify.queryParams.page)) {
                        var o = m.ajaxCreateUrl();
                        (m.isSidebarAjaxClick = !0), History.pushState({ param: Shopify.queryParams }, o, o), m.doAjaxToolbarGetContent(o);
                        var i = t('[data-section-type="collection-template"] .toolbar');
                        i.length || (i = t("[data-search-page]"));
                        var n = i.offset().top;
                        t("body,html").animate({ scrollTop: n }, 600);
                    }
                }
            });
        },
        changeSwatchEditCart: function () {
            t("[data-template-cart-edit] .swatch :radio").on("change", function (e) {
                var a,
                    o = t(this),
                    i = t(this).parents(".product-edit"),
                    n = (t(this).data("image"), i.data("cart-edit-id")),
                    r = window.productVariants[n],
                    s = o.closest("[data-option-index]").data("option-index"),
                    d = i.find(".swatch-element"),
                    l = o.val(),
                    c = i.find("[name=id]"),
                    p = i.find('[data-option-index="0"]').find("input:checked").val(),
                    u = i.find('[data-option-index="1"]').find("input:checked").val();
                i.find('[data-option-index="2"]').find("input:checked").val();
                switch ((d.removeClass("soldout"), d.find(":radio").prop("disabled", !1), s)) {
                    case 0:
                        if (
                            null !=
                            (h = r.find(function (t) {
                                return t.option1 == l && t.option2 == u && t.available;
                            }))
                        )
                            a = h;
                        else
                            a = r.find(function (t) {
                                return t.option1 == l && t.available;
                            });
                        break;
                    case 1:
                        null !=
                            (h = r.find(function (t) {
                                return t.option1 == p && t.option2 == l && t.available;
                            })) && (a = h);
                        break;
                    case 2:
                        var h;
                        null !=
                        (h = r.find(function (t) {
                            return t.option1 == p && t.option2 == u && t.option3 == l && t.available;
                        }))
                            ? (a = h)
                            : console.log("Bundle Error: variant was soldout, on option selection #3");
                }
                c.val(a.id),
                    i.find(".option").text(a.public_title),
                    i.find(".price").html(Shopify.formatMoney(a.price, window.money_format)),
                    a.compare_at_price > a.price
                        ? (i.find(".prices").addClass("special-price"), i.find(".compare-price").html(Shopify.formatMoney(a.compare_at_price, window.money_format)).show())
                        : (i.find(".compare-price").hide(), i.find(".prices").removeClass("special-price")),
                    m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                    m.disableSoldoutSwatchEdit(i),
                    console.log(a),
                    a.featured_image && i.find("#product-featured-image").attr("src", a.featured_image.src);
                var f = t(this).val();
                t(this).parents(".swatch").find("[data-header-option]").text(f);
            }),
                t("[data-template-cart-edit] .single-option-selector").on("change", function () {
                    var e,
                        a = t(this),
                        o = t(this).parents(".product-edit"),
                        i = o.data("cart-edit-id"),
                        n = window.productVariants[i],
                        r = a.data("option"),
                        s = a.val(),
                        d = o.find("[name=id]"),
                        l = o.find('[data-option="option1"]').val(),
                        c = o.find('[data-option="option2"]').val();
                    o.find('[data-option="option3"]').val();
                    switch (r) {
                        case "option1":
                            if (
                                null !=
                                (p = n.find(function (t) {
                                    return t.option1 == s && t.option2 == c && t.available;
                                }))
                            )
                                e = p;
                            else
                                e = n.find(function (t) {
                                    return t.option1 == s && t.available;
                                });
                            break;
                        case "option2":
                            null !=
                                (p = n.find(function (t) {
                                    return t.option1 == l && t.option2 == s && t.available;
                                })) && (e = p);
                            break;
                        case "option3":
                            var p;
                            null !=
                                (p = n.find(function (t) {
                                    return t.option1 == l && t.option2 == c && t.option3 == s && t.available;
                                })) && (e = p);
                    }
                    d.val(e.id),
                        o.find(".price").html(Shopify.formatMoney(e.price, window.money_format)),
                        e.compare_at_price > e.price
                            ? (o.find(".prices").addClass("special-price"), o.find(".compare-price").html(Shopify.formatMoney(e.compare_at_price, window.money_format)).show())
                            : (o.find(".compare-price").hide(), o.find(".prices").removeClass("special-price")),
                        m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                        o.find(".option").text(e.public_title),
                        e.featured_image && o.find("#product-featured-image").attr("src", e.featured_image.src);
                });
        },
        editCart: function () {
            m.isAjaxLoading ||
                i.off("click.editcart").on("click.editcart", "[data-cart-edit]", function (e) {
                    var a = t(this).data("url"),
                        o = t(this).data("id"),
                        i = t(this).data("quantity");
                    t.ajax({
                        type: "get",
                        url: a,
                        cache: !1,
                        dataType: "html",
                        beforeSend: function () {
                            m.showLoading(), r.css({ overflow: "hidden" });
                        },
                        success: function (e) {
                            var a = t("[data-cart-edit-modal]");
                            a.find(".halo-modal-body").html(e),
                                t("#product-edit").find('input[name="quantity"]').val(i),
                                setTimeout(function () {
                                    m.translateBlock("[data-template-cart-edit]"), m.updateCartEdit(o), m.addMoreCart(), m.closeSuccessModal(), m.changeSwatchEditCart();
                                }, 500),
                                t(".product-edit .swatch").each(function () {
                                    var e = t(this).find("input:checked").val();
                                    t(this).find("[data-header-option]").text(e);
                                }),
                                m.hideLoading(),
                                a.fadeIn(600);
                        },
                        error: function (t, e) {
                            m.hideLoading();
                        },
                    });
                });
        },
        addMoreCart: function () {
            var e = t("[data-addmore]");
            t(e)
                .off("click")
                .on("click", function (e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(".product-edit:eq(1)").clone(),
                        o = t(".product-edit").length;
                    (a[0].id = "product-edit-" + o),
                        t(a)
                            .find(".swatch-element")
                            .each(function () {
                                var e = t(this).find('[name="option-0"]').attr("id"),
                                    a = t(this).find('[name="option-1"]').attr("id"),
                                    i = t(this).find('[name="option-2"]').attr("id");
                                t(this)
                                    .find('[name="option-0"]')
                                    .attr("name", "list-" + o + "-option-0")
                                    .attr("id", "list-" + o + "-" + e),
                                    t(this)
                                        .find('[name="option-1"]')
                                        .attr("name", "list-" + o + "-option-1")
                                        .attr("id", "list-" + o + "-" + a),
                                    t(this)
                                        .find('[name="option-2"]')
                                        .attr("name", "list-" + o + "-option-2")
                                        .attr("id", "list-" + o + "-" + i),
                                    t(this)
                                        .find('[data-label="swatch-edit-cart-0"]')
                                        .attr("for", "list-" + o + "-" + e),
                                    t(this)
                                        .find('[data-label="swatch-edit-cart-1"]')
                                        .attr("for", "list-" + o + "-" + a),
                                    t(this)
                                        .find('[data-label="swatch-edit-cart-2"]')
                                        .attr("for", "list-" + o + "-" + i);
                            }),
                        t(a).insertBefore("[data-template-cart-edit] form .cart-meta--action"),
                        t("#product-edit-" + o)
                            .find('input[name="quantity"]')
                            .val(1),
                        t("#product-edit-" + o + " .swatch").each(function () {
                            var e = t(this).find("input:checked").val();
                            t(this).find("[data-header-option]").text(e);
                        }),
                        m.changeSwatchEditCart(),
                        0 == window.use_color_swatch && Shopify.linkOptionSelectors(window._json, "#product-edit-" + o, !0);
                }),
                i.off("click.removeItemCart", "[data-remove-cart]").on("click.removeItemCart", "[data-remove-cart]", function (e) {
                    t(this).parents(".product-edit").remove();
                });
        },
        updateCartEdit: function (e) {
            var a = t("[data-update-cart-edit]");
            t(a)
                .off("click")
                .on("click", function (e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this);
                    if ("disabled" !== a.attr("disabled")) {
                        var o = a.closest("[data-template-cart-edit]").find("form").find(".product-edit"),
                            n = [];
                        o.each(function () {
                            (variantId = t(this).find('[name="id"]').val()), (quantity = parseInt(t(this).find('input[name="quantity"]').val()));
                            var e,
                                a = "";
                            (a = quantity < 1 ? window.router + "/cart/change.js" : window.router + "/cart/add.js"),
                                n.push(((e = { type: "post", url: a, data: "quantity=" + quantity + "&id=" + variantId, dataType: "json", async: !1 }), t.ajax(e)));
                        }),
                            n.length &&
                                t.when.apply(this, n).done(function (e) {
                                    m.updateDropdownCart(), i.hasClass("template-cart") ? window.location.reload() : t("[data-cart-edit-modal] .close-modal").trigger("click");
                                }),
                            m.getPopupShoppingCart(!1, void 0);
                    }
                });
        },
        disableSoldoutSwatchEdit: function (e) {
            var a = e.data("cart-edit-id"),
                o = window.productVariants[a],
                i = e.find("[data-option-index]"),
                n = e.find('[data-option-index="0"]').find("input:checked").val(),
                r = e.find('[data-option-index="1"]').find("input:checked").val();
            e.find('[data-option-index="2"]').find("input:checked").val();
            i.each(function () {
                var e = t(this).data("option-index"),
                    a = t(this).find(".swatch-element");
                switch (e) {
                    case 0:
                        a.each(function () {
                            var e = t(this).data("value");
                            null ==
                            o.find(function (t) {
                                return t.option1 == e && t.available;
                            })
                                ? (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0))
                                : (t(this).removeClass("soldout"), t(this).find(":radio").prop("disabled", !1));
                        });
                        break;
                    case 1:
                        a.each(function () {
                            var e = t(this).data("value");
                            null ==
                            o.find(function (t) {
                                return t.option1 == n && t.option2 == e && t.available;
                            })
                                ? (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0))
                                : (t(this).removeClass("soldout"), t(this).find(":radio").prop("disabled", !1));
                        });
                        break;
                    case 2:
                        a.each(function () {
                            var e = t(this).data("value");
                            null ==
                            o.find(function (t) {
                                return t.option1 == n && t.option2 == r && t.option3 == e && t.available;
                            })
                                ? (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0))
                                : (t(this).removeClass("soldout"), t(this).find(":radio").prop("disabled", !1));
                        });
                }
            }),
                e.find('[data-option-index="1"]').find("input:checked").parents(".swatch-element").hasClass("soldout") && e.find('[data-option-index="1"]').find(".available:not(.soldout)").eq("0").find("label").trigger("click");
        },
        changeQuantityAddToCart: function () {
            var e = "[data-minus-quantity], [data-plus-quantity]",
                a = (t(e), t(".update-cart--template"));
            n.on("click", e, function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this),
                    o = a.siblings('input[name="quantity"]').length > 0 ? a.siblings('input[name="quantity"]') : a.siblings('input[name="group_quantity"]');
                a.closest("[data-item-id]").data("item-id");
                o.length < 1 && (o = a.siblings('input[name="updates[]"]'));
                var i = parseInt(o.val());
                switch (!0) {
                    case a.hasClass("plus"):
                        i += 1;
                        break;
                    case a.hasClass("minus") && i > 0:
                        i -= 1;
                }
                o.val(i), a.parent().find('[type="number"]').trigger("change");
            }),
                a.on("change", function () {
                    var e = t(this),
                        a = e.parents(".cart-product-item"),
                        o = e.data("line"),
                        i = e.val(),
                        n = t(a).data("item-id"),
                        r = a.find(".price");
                    o < i ? e.parent().css("border-color", "red") : (e.parent().css("border-color", "#cdcdcd"), m.doAjaxUpdateCart(n, i, o, r, a));
                }),
                t(".cart-form .remove ").on("click", function (e) {
                    e.preventDefault();
                    var a = t(this).parents(".cart-product-item"),
                        o = t(a).data("item-id");
                    Shopify.removeItem(o, function (e) {
                        m.doUpdateDropdownCart(e),
                            m.initFreeShippingMessage(),
                            t(a).remove(),
                            t(".total-price .price").html(Shopify.formatMoney(e.total_price, window.money_format)),
                            m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                            t(".cart_items ul li").children().length > 0 ? (t(".no-item-cart").hide(), t(".wrapper-cart-template").show()) : (t(".wrapper-cart-template").hide(), t(".no-item-cart").show());
                    });
                });
        },
        initFreeShippingMessage: function () {
            jQuery.getJSON("/cart.js", function (t) {
                m.FreeShippingMessage(t);
            });
        },
        FreeShippingMessage: function (e) {
            var a = window.free_shipping_text.free_shipping_message_1,
                o = window.free_shipping_text.free_shipping_message_2,
                i = window.free_shipping_text.free_shipping_message_3,
                n = window.free_shipping_text.free_shipping_message_4,
                r = 0,
                s = window.free_shipping_text.free_shipping_1,
                d = window.free_shipping_color1,
                l = window.free_shipping_color2,
                c = window.free_shipping_color3,
                p = parseInt(window.free_shipping_price);
            window.multi_lang &&
                translator.isLang2() &&
                ((a = window.lang2.cart.general.free_shipping_message_1), (o = window.lang2.cart.general.free_shipping_message_2), (i = window.lang2.cart.general.free_shipping_message_3), (s = window.lang2.cart.general.free_shipping_1));
            var u = parseInt(e.total_price) / 100,
                h = Math.round((100 * u) / p);
            u >= p || ((r = parseInt(p - u)), (a = o + Shopify.formatMoney(100 * r, window.money_format) + i + "<b>  " + n + " </b>"), (s = window.free_shipping_text.free_shipping_2)),
                h >= 100 && (h = 100),
                0 == h && m.checkItemsInDropdownCart();
            var f = c;
            h <= 30 ? (f = d) : h <= 60 && (f = l);
            var v =
                '<div class="progress_shipping" role="progressbar" style="height: 15px; margin-top: 10px; margin-bottom: 10px;background-color: #e1dfd6;-webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);box-shadow: inset 0 1px 2px rgba(0,0,0,.1);">            <div class="progress-meter" style="position: relative;display: block;height: 100%;background-color: ' +
                f +
                ";text-align: center; line-height: 15px;color: #ffffff;width: " +
                h +
                '%; -webkit-animation: 2s linear 0s normal none infinite running progress-bar-stripes;animation: 2s linear 0s normal none infinite running progress-bar-stripes;background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,rgba(0,0,0,0) 25%,rgba(0,0,0,0) 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,rgba(0,0,0,0) 75%,rgba(0,0,0,0)); background-size: 40px 40px; transition: 0.9s linear; transition-property: width, background-color;">' +
                h +
                "%</div>            </div>";
            t(".free_shipping_progress").html(v),
                t(".free_shipping_massage1").html(a),
                t("#dropdown-cart .summary .free_shipping .text").html(s),
                m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
        },
        doAjaxUpdateCart: function (e, a, o, i, n) {
            var r = t(o).data("line"),
                s = parseFloat(i.data("price")) * a;
            parseFloat(i.data("price"));
            t.ajax({
                type: "post",
                url: "/cart/change.js",
                data: "quantity=" + a + "&id=" + e,
                dataType: "json",
                beforeSend: function () {
                    m.showLoading();
                },
                success: function (e) {
                    0 == a && n.remove(),
                        e.item_count < 1 && (t(".wrapper-cart-template").hide(), t(".no-item-cart").show()),
                        i.html(Shopify.formatMoney(s, window.money_format)),
                        t(".total .price").html(Shopify.formatMoney(e.total_price, window.money_format)),
                        m.updateDropdownCart(),
                        m.initFreeShippingMessage(),
                        m.hideLoading();
                },
                error: function (t) {
                    m.hideLoading();
                },
            });
        },
        toggleVariantsForExpressOrder: function () {
            n.on("click", "[data-toggle-variant]", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this),
                    o = a.data("target");
                a.hasClass("show-options-btn")
                    ? (a.text(window.inventory_text.hide_options),
                      t(o).slideDown(700, function () {
                          a.addClass("hide-options-btn").removeClass("show-options-btn");
                      }))
                    : (a.text(window.inventory_text.show_options),
                      t(o).slideUp(700, function () {
                          a.addClass("show-options-btn").removeClass("hide-options-btn");
                      }));
            });
        },
        initExpressOrderAddToCart: function () {
            n.off("click.addToCartExpress", "[data-express-addtocart]").on("click.addToCartExpress", "[data-express-addtocart]", function (e) {
                e.preventDefault();
                var a = t(this);
                if ("disabled" != a.attr("disabled")) {
                    var o = a.closest(".product-item");
                    0 == o.length && (o = a.closest(".col-options"));
                    var i = o.find("form"),
                        n = i.find("select[name=id]").val();
                    n || (n = i.find("input[name=id]").val());
                    var r = o.find("input[name=quantity]");
                    0 == r.length && (r = o.siblings(".col-qtt").find("input[name=quantity]"));
                    var s = r.val();
                    s || (s = 1), 0 !== parseInt(s) ? ("none" == window.ajax_cart ? i.submit() : (m.expressAjaxAddToCart(n, s, a, i), i.next(".feedback-text").show())) : i.next(".feedback-text").text("Quantity cannot be blank").show();
                }
                return !1;
            });
        },
        expressAjaxAddToCart: function (e, a, o, i) {
            t.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + a + "&id=" + e,
                dataType: "json",
                beforeSend: function () {
                    window.setTimeout(function () {
                        o.text(window.inventory_text.adding + "...");
                    }, 100);
                },
                success: function (t) {
                    window.setTimeout(function () {
                        o.text(window.inventory_text.thank_you);
                    }, 600),
                        window.setTimeout(function () {
                            o.text(window.inventory_text.add_more + "...");
                        }, 1e3),
                        m.updateDropdownCart(),
                        o.addClass("add_more"),
                        i.next(".feedback-text").text(window.inventory_text.cart_feedback);
                },
                error: function (e, a) {
                    t(".ajax-error-message").text(t.parseJSON(e.responseText).description),
                        m.showModal(".ajax-error-modal"),
                        window.setTimeout(function () {
                            o.text(window.inventory_text.add_to_cart);
                        }, 400);
                },
            });
        },
        initAddToCart: function () {
            n.off("click.addToCart", "[data-btn-addToCart]").on("click.addToCart", "[data-btn-addToCart]", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this),
                    o = t(a.data("form-id")).serialize();
                if ("disabled" !== a.attr("disabled")) {
                    var i = a.closest(".product-item");
                    if (i.length < 1) {
                        var n = a.closest('[data-section-type="product"]');
                        n.length || (n = a.closest(".quickview-tpl")), (i = n.find(".product-shop"));
                    }
                    var r = i.find('form[action="/cart/add"]'),
                        s = i.find(".product-grid-image").data("collections-related") || n.data("collections-related");
                    switch (window.ajax_cart) {
                        case "none":
                            r.submit();
                            break;
                        case "normal":
                            var d = i.find(".product-title").html(),
                                l = i.find(".product-grid-image img").attr("data-srcset");
                            l ||
                                (l =
                                    i.siblings(".product-photos").find('.slick-current img[id|="product-featured-image"]').attr("src") ||
                                    i.siblings(".product-photos").find('.slick-current img[id|="qv-product-featured-image"]').attr("src")),
                                m.doAjaxAddToCartNormal(o, d, l);
                            break;
                        case "upsell":
                            m.doAjaxAddToCart(o, s);
                    }
                }
                return !1;
            }),
                m.closeSuccessModal();
        },
        initGroupedAddToCart: function () {
            m.changeVariantSelectOption(),
                n.off("click.GroupedAddToCart", "[data-grouped-addToCart]").on("click.GroupedAddToCart", "[data-grouped-addToCart]", function (e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = t(a.data("form-id")).serialize();
                    if ("disabled" !== a.attr("disabled")) {
                        var i = a.closest('[data-section-type="product"]'),
                            n = i.find(".product-shop"),
                            r = n.find('form[action="/cart/add"]'),
                            s = i.data("collections-related"),
                            d = r.find(".grouped-product");
                        (Shopify.queue = []),
                            d.each(function () {
                                (variantId = t(this).find("input[type=hidden]").attr("value")),
                                    (quantity = parseInt(t(this).find("input[name=group_quantity]").val())),
                                    quantity > 0 && "" !== variantId && Shopify.queue.push({ variantId: variantId, quantity: parseInt(quantity, 10) || 0 });
                            }),
                            (Shopify.moveAlong = function () {
                                if (!Shopify.queue.length) {
                                    switch (window.ajax_cart) {
                                        case "none":
                                            r.submit();
                                            break;
                                        case "normal":
                                            var t = n.find(".product-title").html(),
                                                e = n.find(".product-grid-image img").attr("src");
                                            e ||
                                                (e =
                                                    n.siblings(".product-photos").find('.slick-current img[id|="product-featured-image"]').attr("src") ||
                                                    n.siblings(".product-photos").find('.slick-current img[id|="qv-product-featured-image"]').attr("src")),
                                                m.doAjaxAddToCartNormal(o, t, e);
                                            break;
                                        case "upsell":
                                            m.doAjaxAddToCart(o, s);
                                    }
                                    return !1;
                                }
                                var a = Shopify.queue.shift();
                                Shopify.addItem(a.variantId, a.quantity, Shopify.moveAlong);
                            }),
                            Shopify.moveAlong();
                    }
                }),
                m.closeSuccessModal();
        },
        changeVariantSelectOption: function () {
            n.on("change", "[data-select-change-variant]", function () {
                var e = t(this).val(),
                    a = t(this).find("option:selected").data("img"),
                    o = t(this).find("option:selected").data("price"),
                    i = t(this).closest(".grouped-product");
                i.find("input[type=hidden]").val(e),
                    i.find(".product-img img").attr({ src: a }),
                    i.find("[data-price-change]").html(Shopify.formatMoney(o, window.money_format)),
                    m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), ".grouped-product span.money", "money_format");
            });
        },
        closeSuccessModal: function () {
            var e = t("[data-ajax-cart-success], [data-quickview-modal], [data-compare-modal], [data-compare-message-modal]"),
                a = t("[data-cart-edit-modal]"),
                o = e.find(".close-modal, .continue-shopping"),
                n = e.find(".halo-modal-content"),
                s = a.find(".close-modal"),
                d = a.find(".halo-modal-content");
            o.click(function (t) {
                t.preventDefault(),
                    e.fadeOut(500, function () {
                        r.removeClass("halo-modal-open"), r.css({ overflow: "" }), i.hasClass("template-cart") && window.location.reload();
                    });
            }),
                e.on("click", function (t) {
                    n.is(t.target) ||
                        n.has(t.target).length ||
                        e.fadeOut(500, function () {
                            r.removeClass("halo-modal-open"), r.css({ overflow: "" }), i.hasClass("template-cart") && window.location.reload();
                        });
                }),
                s.on("click", function (t) {
                    t.preventDefault(),
                        a.fadeOut(500, function () {
                            r.removeClass("halo-modal-open"), r.css({ overflow: "" });
                        });
                }),
                a.on("click", function (t) {
                    d.is(t.target) ||
                        d.has(t.target).length ||
                        a.fadeOut(500, function () {
                            r.removeClass("halo-modal-open"), r.css({ overflow: "" });
                        });
                });
        },
        doAjaxAddToCartNormal: function (e, a, o) {
            t.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: e,
                dataType: "json",
                beforeSend: function () {
                    m.showLoading();
                },
                success: function () {
                    var e = t("[data-ajax-cart-success]"),
                        i = e.find(".cart-modal-content");
                    i.find(".ajax-product-title").html(m.translateText(a)),
                        i.find(".ajax-product-image").attr("src", o),
                        i.find(".message-added-cart").show(),
                        e.fadeIn(600, function () {
                            t("[data-quickview-modal]").is(":visible") && t("[data-quickview-modal]").hide(), m.closeLookbookModal();
                        }),
                        m.updateDropdownCart();
                },
                error: function (e) {
                    t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.showModal(".ajax-error-modal");
                },
                complete: function () {
                    m.hideLoading();
                },
            });
        },
        doAjaxAddToCart: function (e, a, o) {
            t.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: e,
                dataType: "json",
                async: !1,
                beforeSend: function () {
                    m.showLoading();
                },
                success: function (t) {
                    if (o) {
                        var e = "FBT-BUNDLE-" + meta.product.id;
                        m.apply_discount(e), (window.location.href = "/cart"), m.showloading();
                    } else m.getPopupShoppingCart(!0, a);
                },
                error: function (e) {
                    t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.showModal(".ajax-error-modal");
                },
                complete: function () {
                    m.hideLoading();
                },
            });
        },
        getPopupShoppingCart: function (e, a) {
            var o = t("[data-ajax-cart-success]"),
                i = o.find(".cart-popup-content"),
                n = o.find(".cart-popup-coll-related");
            t.get(window.router + "/cart?view=json", function (o) {
                if ((i.html(o), null != a)) {
                    var r = a.split("/collections")[0];
                    e &&
                        (a != r + "/collections/?view=related" ? n.load("" + a) : n.load(r + "/collections/all?view=related"),
                        t(document).ajaxComplete(function (e, o, i) {
                            if ("/collections/all?view=related" === i.url || i.url === "" + a)
                                try {
                                    m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "[data-ajax-cart-success] span.money", "money_format");
                                } catch (t) {
                                    console.log(t);
                                }
                        }));
                }
            }).always(function () {
                m.updateDropdownCart(),
                    (m.ellaTimeout = setTimeout(function () {
                        if ((m.translateBlock("[data-ajax-cart-success]"), t(".shopify-product-reviews-badge").length && t(".spr-badge").length))
                            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                    }, 1e3)),
                    m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "[data-ajax-cart-success] span.money", "money_format"),
                    e &&
                        o.fadeIn(600, function () {
                            t("[data-quickview-modal]").is(":visible") && t("[data-quickview-modal]").hide(), m.closeLookbookModal();
                        });
            });
        },
        doAjaxUpdatePopupCart: function (e, a) {
            t.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: { id: a, quantity: e },
                dataType: "json",
                beforeSend: function () {
                    m.showLoading();
                },
                success: function (t) {
                    m.getPopupShoppingCart(!1), m.checkBundleProducts();
                },
                error: function (e) {
                    t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.showModal(".ajax-error-modal");
                },
                complete: function () {
                    m.hideLoading();
                },
            });
        },
        initChangeQuantityButtonEvent: function () {
            var e = "[data-minus-quantity-cart], [data-plus-quantity-cart]";
            t(e);
            n.off("click.updateCart").on("click.updateCart", e, function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this),
                    o = a.closest("[data-product-id]").data("product-id"),
                    i = parseInt(a.siblings('input[name="quantity"]').val());
                a.hasClass("plus") ? (i += 1) : (i -= 1), m.doAjaxUpdatePopupCart(i, o);
            });
        },
        initQuantityInputChangeEvent: function () {
            n.on("change", "[data-quantity-input]", function () {
                var e = t(this).closest("[data-product-id]").data("product-id"),
                    a = parseInt(t(this).val());
                m.doAjaxUpdatePopupCart(a, e);
            });
        },
        removeCartItem: function () {
            n.on("click", ".cart-remove", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this).closest("[data-product-id]").data("product-id");
                m.doAjaxUpdatePopupCart(0, a);
            });
        },
        initSoldOutProductShop: function () {
            var e = t(".product-shop [data-soldOut-product]");
            e.length &&
                e.each(function () {
                    var e = t(this),
                        a = e.data("items").toString().split(","),
                        o = e.data("hours").toString().split(","),
                        i = Math.floor(Math.random() * a.length),
                        n = Math.floor(Math.random() * o.length);
                    e.find(".items-count").text(a[i]), e.find(".hours-num").text(o[n]);
                });
        },
        initCustomerViewProductShop: function () {
            var e = t(".product-shop [data-customer-view]");
            e.length &&
                e.each(function () {
                    var e = t(this);
                    setInterval(function () {
                        var t = e.data("customer-view").split(","),
                            a = Math.floor(Math.random() * t.length);
                        e.find("label").text(t[a]);
                    }, 5e3);
                });
        },
        initProductMoreview: function (t) {
            var e = t.find(".slider-for"),
                a = t.find(".slider-nav"),
                o = a.data("vertical");
            if (
                (e.hasClass("slick-initialized") ||
                    a.hasClass("slick-initialized") ||
                    (e.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        fade: !0,
                        asNavFor: a,
                        draggable: !1,
                        adaptiveHeight: !1,
                        get arrows() {
                            return "skin_1" == window.product_style ? (this.arrows = !0) : (this.arrows = !1);
                        },
                        get nextArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.nextArrow =
                                      '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>');
                        },
                        get prevArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.prevArrow =
                                      '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>');
                        },
                    }),
                    a.slick({
                        infinite: !0,
                        slidesToShow: a.data("rows"),
                        vertical: o,
                        slidesToScroll: 1,
                        asNavFor: e,
                        focusOnSelect: !0,
                        get nextArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.nextArrow =
                                      '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>');
                        },
                        get prevArrow() {
                            return "layout_style_1170" == window.layout_style
                                ? (this.prevArrow =
                                      '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                : (this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>');
                        },
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    get dots() {
                                        if (1 == o) return (dots = !0);
                                    },
                                },
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    get dots() {
                                        if (1 == o) return (dots = !0);
                                    },
                                },
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    get dots() {
                                        if (1 == o) return (dots = !0);
                                    },
                                },
                            },
                            {
                                breakpoint: 360,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    get dots() {
                                        if (1 == o) return (dots = !0);
                                    },
                                },
                            },
                        ],
                    })),
                "variant_grouped" === window.color_swatch_style && window.use_color_swatch)
            ) {
                var i = t.closest("[data-more-view-product]").siblings(".product-shop").find(".swatch").find(".swatch-element.color").find(":radio:checked");
                if (i.length) {
                    var n = i.data("filter");
                    void 0 !== n && (a.slick("slickUnfilter"), e.slick("slickUnfilter"), a.find(n).length && e.find(n).length && (a.slick("slickFilter", n).slick("refresh"), e.slick("slickFilter", n).slick("refresh")));
                }
            }
        },
        changeSwatch: function (e) {
            n.on("change", e, function () {
                var a = t(this).data("filter"),
                    o = t(this).closest(".swatch").attr("data-option-index"),
                    i = t(this).val();
                (t(this).closest("form").find(".single-option-selector").eq(o).val(i).trigger("change"), null == a) && t("input[data-filter]").is(":checked") && (a = t("input[data-filter]:checked").data("filter"));
                if ("variant_grouped" === window.color_swatch_style && window.use_color_swatch && void 0 !== a) {
                    var n = t(e).closest(".product-shop");
                    if (n.closest(".product-slider").length) {
                        (d = (r = n.closest(".product-slider").find("[data-moreview-product-slider]")).find(".slider-for")).slick("slickUnfilter"), d.find(a).length && d.slick("slickFilter", a).slick("refresh"), m.initZoom();
                    } else {
                        var r;
                        if ((r = n.prev("[data-more-view-product]")).length) {
                            var s = r.find(".slider-nav"),
                                d = r.find(".slider-for");
                            s.slick("slickUnfilter"), d.slick("slickUnfilter"), s.find(a).length && d.find(a).length && (s.slick("slickFilter", a).slick("refresh"), d.slick("slickFilter", a).slick("refresh"));
                        }
                        m.initZoom();
                    }
                }
            });
        },
        productPageInitProductTabs: function () {
            var e = t(".tabs__product-page"),
                a = e.find("[data-tapTop]"),
                o = e.find("[data-TabContent]");
            t(".product-template-skin-1").length && (e = t(".product-review")),
                a.off("click").on("click", function (e) {
                    e.preventDefault(), e.stopPropagation();
                    var i = t(this),
                        n = t(i.data("target")),
                        r = i.closest(".list-tabs");
                    r.length
                        ? t(this).hasClass("active") || (a.removeClass("active"), o.removeClass("active"), i.addClass("active"), r.next().find(i.data("target")).addClass("active"))
                        : t(".product-template-full-width").length
                        ? t(this).hasClass("active")
                            ? (i.removeClass("active"),
                              n.hide(0, function () {
                                  t(document.body).trigger("sticky_kit:recalc");
                              }))
                            : (i.addClass("active"),
                              n.show(0, function () {
                                  t(document.body).trigger("sticky_kit:recalc");
                              }))
                        : t(".has-sticky-product-img").length
                        ? t(this).hasClass("active")
                            ? (i.removeClass("active"), n.hide())
                            : (i.addClass("active"), n.show())
                        : t(this).hasClass("active")
                        ? (i.removeClass("active"), n.slideUp())
                        : (i.addClass("active"), n.slideDown());
                });
            n.on("click.triggerTabsReviews", ".product-shop .spr-badge", function () {
                if (e.length && (t("html,body").animate({ scrollTop: e.offset().top }, 400), !t(".product-template-skin-1").length)) {
                    var a = e.find('[data-target="#collapse-tab2"]');
                    a.hasClass("active") || a.trigger("click");
                }
            }),
                t(".product-template-full-width").length &&
                    n.on("click", ".product-template-full-width .spr-summary-actions-newreview", function () {
                        t(document.body).trigger("sticky_kit:recalc");
                    });
        },
        initStickyForProductFullWidth: function () {
            var e,
                a = t(".product-template-full-width"),
                o = s.innerWidth(),
                i = a.find("[data-sticky-1]"),
                n = a.find("[data-sticky-2]"),
                r = a.find("[data-sticky-3]"),
                d = function () {
                    i.stick_in_parent({ offset_top: 70, inner_scrolling: !1 }),
                        r.stick_in_parent({ offset_top: 68 }),
                        n
                            .stick_in_parent({ offset_top: 50 })
                            .on("sticky_kit:bottom", function () {
                                n.addClass("sticky-on-bottom");
                            })
                            .on("sticky_kit:unbottom", function () {
                                n.removeClass("sticky-on-bottom");
                            });
                };
            a.length &&
                (o >= 1200 && d(),
                s.off("resize.sticky").on("resize.sticky", function () {
                    clearTimeout(e),
                        (e = setTimeout(function () {
                            var t = s.innerWidth();
                            t < 1200 && o >= 1200 ? (i.trigger("sticky_kit:detach"), r.trigger("sticky_kit:detach"), n.trigger("sticky_kit:detach")) : t >= 1200 && o < 1200 && d(), (o = t);
                        }, 0));
                }));
        },
        initQuickView: function () {
            i.off("click.initQuickView", ".quickview-button").on("click.initQuickView", ".quickview-button", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this).attr("id");
                m.doAjaxShowQuickView(a), m.closeSuccessModal();
            });
        },
        doAjaxShowQuickView: function (e) {
            m.isAjaxLoading ||
                t.ajax({
                    type: "get",
                    url: window.router + "/products/" + e + "?view=quickview",
                    beforeSend: function () {
                        m.showLoading(), r.css({ overflow: "hidden" });
                    },
                    success: function (a) {
                        var o = t("[data-quickview-modal]");
                        o.find(".halo-modal-body").html(a),
                            setTimeout(function () {
                                if (
                                    (m.translateBlock("[data-quickview-modal]"),
                                    m.initProductMoreview(t("[data-more-view-product-qv] .product-img-box")),
                                    m.initSoldOutProductShop(),
                                    m.initCustomerViewProductShop(),
                                    m.changeSwatch(".quickview-tpl .swatch :radio"),
                                    m.initCountdownNormal(),
                                    m.initZoom(),
                                    m.setAddedForWishlistIcon(e),
                                    t.getScript("https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-595b0ea2fb9c5869").done(function () {
                                        "undefined" != typeof addthis && (addthis.init(), addthis.layers.refresh());
                                    }),
                                    t(".shopify-product-reviews-badge").length && t(".spr-badge").length)
                                )
                                    return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            }, 500),
                            m.hideLoading(),
                            o.fadeIn(600, function () {
                                t("[data-ajax-cart-success]").is(":visible") && t("[data-ajax-cart-success]").hide();
                            });
                    },
                    error: function (e, a) {
                        t(".ajax-error-message").text(t.parseJSON(e.responseText).description), m.hideLoading(), m.showModal(".ajax-error-modal");
                    },
                });
        },
        initZoom: function () {
            var e = t(".product-img-box [data-zoom]");
            s.width() >= 1200 ? e.zoom() : e.trigger("zoom.destroy");
        },
        openSearchForm: function () {
            t(".wrapper-header").find(".search-form");
            n.off("click.toggleSearch", "[data-search-mobile-toggle]").on("click.toggleSearch", "[data-search-mobile-toggle]", function (t) {
                t.preventDefault(), t.stopPropagation(), r.addClass("search-open");
            }),
                n.off("click.hideSearch").on("click.hideSearch", function (e) {
                    var a = t(".wrapper-header .search-form .search-bar"),
                        o = t(".wrapper-header .header-search__product"),
                        i = t(".wrapper-header .header-search__trending"),
                        n = t(".wrapper-overlay");
                    a.is(e.target) || a.has(e.target).length || o.has(e.target).length || i.has(e.target).length || n.has(e.target).length || (r.removeClass("search-open"), t(".quickSearchResultsWrap").hide());
                });
        },
        stickyFixedTopMenu: function () {
            window.fixtop_menu &&
                (window.innerWidth >= 1200
                    ? (t("[data-sticky-mb]").unstick(),
                      setTimeout(function () {
                          t(".site-header").css("height", ""),
                              t("[data-sticky-pc]").sticky({ zIndex: 3 }),
                              t("[data-sticky-pc]").on("sticky-start", function () {
                                  i.addClass("has_sticky");
                              }),
                              t("[data-sticky-pc]").on("sticky-end", function () {
                                  i.removeClass("has_sticky");
                              });
                      }, 100))
                    : (t("[data-sticky-pc]").unstick(),
                      setTimeout(function () {
                          t(".site-header").css("height", ""), t("[data-sticky-mb]").sticky({ zIndex: 3 });
                      }, 100)));
        },
        handleScrollDown: function () {
            t("[data-scroll-down]").each(function () {
                var e = t(this),
                    a = e.closest(".shopify-section").next(".shopify-section").attr("id");
                e.attr("href", "#" + a),
                    n.off("click.handleScrollDown", "[data-scroll-down]").on("click.handleScrollDown", "[data-scroll-down]", function (e) {
                        e.preventDefault();
                        var a = t(this.getAttribute("href"));
                        a.length && t("html, body").stop().animate({ scrollTop: a.offset().top }, 500);
                    });
            });
        },
        initStickyAddToCart: function () {
            var e = t("[data-sticky-add-to-cart]"),
                a = e.find(".pr-active"),
                o = e.find(".pr-swatch");
            if (e.length) {
                var r = t("#add-to-cart-form .groups-btn").offset().top;
                t(window).scroll(function () {
                    t(this).scrollTop() > r ? i.addClass("show_sticky") : i.removeClass("show_sticky");
                }),
                    a.off("click.showListVariant").on("click.showListVariant", function (t) {
                        t.preventDefault(), e.toggleClass("open-sticky");
                    }),
                    n.off("click.hideVariantsOption").on("click.hideVariantsOption", function (t) {
                        a.is(t.target) || 0 !== a.has(t.target).length || e.removeClass("open-sticky");
                    }),
                    o.off("click.activeVar").on("click.activeVar", function (i) {
                        var n = t(this),
                            r = n.text(),
                            s = n.data("value"),
                            d = n.data("img");
                        return (
                            o.removeClass("active"),
                            n.addClass("active"),
                            e.toggleClass("open-sticky"),
                            e.find(".action input[type=hidden]").val(s),
                            a.attr("data-value", s).text(r),
                            t('#add-to-cart-form [data-value-sticky="' + s + '"]').each(function () {
                                var e = t(this).data("value");
                                t('[data-value="' + e + '"]')
                                    .closest(".swatch")
                                    .find("#" + e)
                                    .click();
                            }),
                            n.hasClass("sold-out")
                                ? e.find(".sticky-add-to-cart").val(window.inventory_text.sold_out).addClass("disabled").attr("disabled", "disabled")
                                : e.find(".sticky-add-to-cart").removeClass("disabled").removeAttr("disabled").val(window.inventory_text.add_to_cart),
                            t(".pr-img img").attr({ src: d }),
                            !1
                        );
                    }),
                    n.on("click", "[data-sticky-btn-addToCart]", function (e) {
                        return (
                            e.preventDefault(),
                            t("#add-to-cart-form [data-btn-addToCart]").length
                                ? t("#add-to-cart-form [data-btn-addToCart]").click()
                                : t("#add-to-cart-form [data-grouped-addToCart]").length && t("#add-to-cart-form [data-grouped-addToCart]").click(),
                            !1
                        );
                    }),
                    (function () {
                        var i = t("#product-selectors option:selected").val(),
                            n = e.find('.pr-swatch[data-value="' + i + '"]'),
                            r = n.html();
                        a.html(r), n.addClass("active");
                        var s = n.data("img");
                        t(".pr-img img").attr({ src: s }),
                            t(".swatch .swatch-element").each(function (e) {
                                var a = t(this).find("input:radio").attr("id");
                                t('.swatch input.text[data-value="' + a + '"]').appendTo(t(this));
                            }),
                            t(".selector-wrapper").change(function () {
                                var e = t("#product-selectors").val();
                                if (
                                    (t(".sticky_form .pr-selectors li").each(function (a) {
                                        t(this).find("a").data("value") == e ? t(this).find("a").addClass("active") : t(this).find("a").removeClass("active");
                                    }),
                                    t("#product-selectors")
                                        .change(function () {
                                            var e = "";
                                            t("#product-selectors option:selected").each(function () {
                                                e += t(this).data("imge");
                                            }),
                                                t(".pr-img img").attr({ src: e });
                                        })
                                        .trigger("change"),
                                    o.hasClass("active"))
                                ) {
                                    var i = t(".sticky_form .pr-swatch.active").html();
                                    t(".sticky_form .action input[type=hidden]").val(e), a.html(i), a.attr("data-value", e);
                                }
                            });
                    })();
            }
        },
        createWishListTplItem: function (e) {
            var a = t("[data-wishlist-container]");
            jQuery.getJSON(window.router + "/products/" + e + ".js", function (e) {
                var o = "",
                    i = Shopify.formatMoney(e.price_min, window.money_format);
                (o += '<div class="grid-item" data-wishlist-added="wishlist-' + e.id + '">'),
                    (o += '<div class="inner product-item" data-product-id="product-' + e.handle + '">'),
                    (o += '<div class="column col-img"><div class="product-image">'),
                    (o += '<a href="' + e.url + '" class="product-grid-image" data-collections-related="/collections/all?view=related">'),
                    (o += '<img src="' + e.featured_image + '" alt="' + e.featured_image.alt + '">'),
                    (o += "</a></div></div>"),
                    (o += '<div class="column col-prod">'),
                    (o += '<a class="product-title" href="' + e.url + '" title="' + e.title + '">' + e.title + "</a>"),
                    (o += '<div class="product-vendor">'),
                    (o += '<a href="' + window.router + "/collections/vendors?q=" + e.vendor + '" title="' + e.vendor + '">' + e.vendor + "</a></div></div>"),
                    (o += '<div class="column col-price text-center"><div class="price-box">' + i + "</div></div>"),
                    (o += '<div class="column col-options text-center">'),
                    (o += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + e.id + '" data-id="product-actions-' + e.id + '" enctype="multipart/form-data">'),
                    e.available
                        ? (1 == e.variants.length &&
                              (o +=
                                  '<button data-btn-addToCart class="btn add-to-cart-btn" data-form-id="#wishlist-product-form-' +
                                  e.id +
                                  '" type="submit">' +
                                  window.inventory_text.add_to_cart +
                                  '</button><input type="hidden" name="id" value="' +
                                  e.variants[0].id +
                                  '" />'),
                          e.variants.length > 1 && (o += '<a class="btn" title="' + e.title + '" href="' + e.url + '">' + window.inventory_text.select_options + "</a>"))
                        : (o += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">' + window.inventory_text.unavailable + "</button>"),
                    (o += "</form></div>"),
                    (o +=
                        '<div class="column col-remove text-center"><a class="whislist-added" href="#" data-product-handle="' +
                        e.handle +
                        '" data-icon-wishlist data-id="' +
                        e.id +
                        '"><svg class="closemnu" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg></a></div>'),
                    (o += "</div></div>"),
                    a.append(o);
                var n = t(".wrapper-wishlist a.share").attr("href");
                (n += encodeURIComponent(e.title + "\nPrice: " + i.replace(/(<([^>]+)>)/gi, "") + "\nLink: " + window.location.protocol + "//" + window.location.hostname + e.url + "\n\n")), t(".wrapper-wishlist a.share").attr("href", n);
            });
        },
        initWishListPagging: function () {
            var e = JSON.parse(localStorage.getItem("items")),
                a = t("#wishlist-paginate"),
                o = '<li class="text disabled prev"><a href="#" title="' + window.inventory_text.previous + '"><i class="fa fa-angle-left" aria-hidden="true"></i><span>' + window.inventory_text.previous + "</span></a></li>",
                i = t("[data-wishlist-container]");
            a.children().remove();
            var n = Math.ceil(e.length / 3);
            if (n <= 1) i.children().show();
            else {
                for (var r = 0; r < n; r++) {
                    var s = r + 1;
                    o += 0 === r ? '<li class="active"><a data-page="' + s + '" href="' + s + '" title="' + s + '">' + s + "</a></li>" : '<li><a data-page="' + s + '" href="' + s + '" title="' + s + '">' + s + "</a></li>";
                }
                (o += '<li class="text next"><a href="#" title="' + window.inventory_text.next + '"><span>' + window.inventory_text.next + '</span><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>'),
                    a.append(o),
                    i.children().each(function (e, a) {
                        e >= 0 && e < 3 ? t(a).show() : t(a).hide();
                    }),
                    a.off("click.wl-pagging").on("click.wl-pagging", "li a", function (e) {
                        e.preventDefault();
                        var o = t(this).parent().hasClass("prev"),
                            r = t(this).parent().hasClass("next"),
                            s = t(this).data("page");
                        if (o) {
                            var d = parseInt(t(this).parent().siblings(".active").children().data("page"));
                            s = d - 1;
                        }
                        if (r) {
                            d = parseInt(t(this).parent().siblings(".active").children().data("page"));
                            s = d + 1;
                        }
                        i.children().each(function (e, a) {
                            e >= 3 * (s - 1) && e < 3 * s ? t(a).show() : t(a).hide();
                        }),
                            1 === s
                                ? (a.find(".prev").addClass("disabled"), a.find(".next").removeClass("disabled"))
                                : s === n
                                ? (a.find(".next").addClass("disabled"), a.find(".prev").removeClass("disabled"))
                                : (a.find(".prev").removeClass("disabled"), a.find(".next").removeClass("disabled")),
                            t(this).parent().siblings(".active").removeClass("active"),
                            a
                                .find('[data-page="' + s + '"]')
                                .parent()
                                .addClass("active");
                    });
            }
        },
        initWishLists: function () {
            if ("undefined" != typeof Storage) {
                var t = JSON.parse(localStorage.getItem("items"));
                if (t.length <= 0) return;
                t.forEach(function (t) {
                    m.createWishListTplItem(t);
                }),
                    this.initWishListPagging(),
                    this.translateBlock(".wishlist-page");
            } else alert("Sorry! No web storage support..");
        },
        setAddedForWishlistIcon: function (e) {
            var a = t('[data-product-handle="' + e + '"]');
            u.indexOf(e) >= 0 ? (a.addClass("whislist-added"), a.find(".wishlist-text").text(window.inventory_text.remove_wishlist)) : (a.removeClass("whislist-added"), a.find(".wishlist-text").text(window.inventory_text.add_wishlist));
        },
        doAddOrRemoveWishlish: function () {
            n.off("click.addOrRemoveWishlist", "[data-icon-wishlist]").on("click.addOrRemoveWishlist", "[data-icon-wishlist]", function (e) {
                e.preventDefault();
                var a = t(this),
                    o = a.data("id"),
                    i = a.data("product-handle"),
                    n = u.indexOf(i);
                a.hasClass("whislist-added")
                    ? (a.removeClass("whislist-added"),
                      a.find(".wishlist-text").text(window.inventory_text.add_wishlist),
                      t('[data-wishlist-added="wishlist-' + o + '"]').length && t('[data-wishlist-added="wishlist-' + o + '"]').remove(),
                      u.splice(n, 1),
                      localStorage.setItem("items", JSON.stringify(u)),
                      t("[data-wishlist-container]").length && m.initWishListPagging())
                    : (a.addClass("whislist-added"),
                      a.find(".wishlist-text").text(window.inventory_text.remove_wishlist),
                      t("[data-wishlist-container]").length && m.createWishListTplItem(i),
                      u.push(i),
                      localStorage.setItem("items", JSON.stringify(u))),
                    m.setAddedForWishlistIcon(i);
            });
        },
        initWishListIcons: function () {
            var e = localStorage.getItem("items") ? JSON.parse(localStorage.getItem("items")) : [];
            if (e.length)
                for (var a = 0; a < e.length; a++) {
                    var o = t('[data-product-handle="' + e[a] + '"]');
                    o.addClass("whislist-added"), o.find(".wishlist-text").text(window.inventory_text.remove_wishlist);
                }
        },
        setAddedForCompareIcon: function (e) {
            t('[data-compare-product-handle="' + e + '"]'), h.indexOf(e);
            var a = t("[data-compare-count]");
            (compareItems = localStorage.getItem("compareArr") ? JSON.parse(localStorage.getItem("compareArr")) : []),
                (totalProduct = Math.ceil(compareItems.length)),
                a.text(totalProduct),
                totalProduct >= 2 ? t(".compare-link").addClass("open") : t(".compare-link").removeClass("open");
        },
        doAddOrRemoveCompare: function () {
            n.off("click.doAddOrRemoveCompare", "[data-icon-compare]").on("click.doAddOrRemoveCompare", "[data-icon-compare]", function (e) {
                e.preventDefault();
                var a = t(this),
                    o = a.data("id"),
                    i = a.data("compare-product-handle"),
                    n = h.indexOf(i);
                a.hasClass("compare-added")
                    ? (a.removeClass("compare-added"), t('[data-compare-added="compare-' + o + '"]').length && t('[data-compare-added="compare-' + o + '"]').remove(), h.splice(n, 1), localStorage.setItem("compareArr", JSON.stringify(h)))
                    : (h.push(i), localStorage.setItem("compareArr", JSON.stringify(h)), m.createCompareItem(i), a.addClass("compare-added")),
                    m.setAddedForCompareIcon(i);
            });
        },
        initCompareIcons: function () {
            var e = t("[data-compare-count]");
            if (((totalProduct = Math.ceil(h.length)), e.text(totalProduct), h.length)) {
                for (var a = 0; a < h.length; a++) {
                    t('[data-compare-product-handle="' + h[a] + '"]').addClass("compare-added");
                }
                if ("undefined" != typeof Storage) {
                    if (h.length <= 0) return;
                    setTimeout(function () {
                        h.forEach(function (t) {
                            m.createCompareItem(t), m.setAddedForCompareIcon(t);
                        });
                    }, 1500);
                } else alert("Sorry! No web storage support..");
            }
        },
        initCompareSelected: function () {
            (compareModal = t("[data-compare-modal]")),
                (compareModalProduct = compareModal.find(".product-grid")),
                (compareModalMessage = t("[data-compare-message-modal]")),
                n.off("click.compareSelected", "[data-compare-selected]").on("click.compareSelected", "[data-compare-selected]", function (t) {
                    t.preventDefault(),
                        t.stopPropagation(),
                        "undefined" != typeof Storage
                            ? h.length <= 1
                                ? (compareModalMessage.find(".halo-modal-body").text(window.inventory_text.message_compare),
                                  compareModalMessage.fadeIn(500, function () {
                                      r.addClass("halo-modal-open");
                                  }),
                                  i.addClass("has-popup"))
                                : (h.forEach(function (t) {
                                      m.removeCompareItem(t);
                                  }),
                                  compareModal.fadeIn(600, function () {
                                      r.addClass("halo-modal-open");
                                  }),
                                  m.removeAllCompareItem())
                            : alert("Sorry! No web storage support.."),
                        m.closeSuccessModal(),
                        m.translateBlock(".ajax-compare"),
                        m.translateBlock(".compare-message-modal");
                });
        },
        createCompareItem: function (e) {
            var a = t("[data-compare-modal]").find(".halo-modal-body .compare-content .product-grid"),
                o = t("[data-compare-modal]").find(".halo-modal-body .compare-content .rating"),
                i = t("[data-compare-modal]").find(".halo-modal-body .compare-content .description"),
                n = (t("[data-compare-modal]").find(".halo-modal-body .compare-content .collection"), t("[data-compare-modal]").find(".halo-modal-body .compare-content .availability")),
                r = t("[data-compare-modal]").find(".halo-modal-body .compare-content .product-type"),
                s = t("[data-compare-modal]").find(".halo-modal-body .compare-content .product-sku"),
                d = t("[data-compare-modal]").find(".option1"),
                l = t("[data-compare-modal]").find(".option2"),
                c = t("[data-compare-modal]").find(".option3");
            jQuery.getJSON("/products/" + e + ".js", function (e) {
                var p = "",
                    u = "",
                    h = "",
                    f = "",
                    m = "",
                    v = "",
                    g = "",
                    w = "",
                    b = (Shopify.formatMoney(e.price_min, window.money_format), '<span class="shopify-product-reviews-badge" data-id="' + e.id + '"></span>'),
                    C = e.description.substring(0, 100) + "...",
                    y = ((h = new DOMParser().parseFromString(C, "text/html")), ((e.compare_at_price - e.price) / e.compare_at_price) * 100),
                    k = e.tags,
                    x = Math.floor(y),
                    S = e.options;
                t.each(S, function (t, a) {
                    var o = a.position,
                        i = a.name.toLowerCase(),
                        n = a.values,
                        r = "";
                    n.forEach(function (t, e) {
                        t && (e > 0 && (r += ", "), (r += t));
                    }),
                        (w += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>'),
                        (g += "" == r || "Default Title" == r ? '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>' : '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + r + "</div>");
                    var s = window.option_ptoduct1,
                        p = window.option_ptoduct2;
                    (optionThreeValue = window.option_ptoduct3),
                        1 == o && (i == s ? (d.append(g), l.append(w), c.append(w)) : i == p ? (d.append(w), l.append(g), c.append(w)) : "title" == i ? (d.append(w), l.append(w), c.append(w)) : (d.append(w), l.append(w), c.append(g))),
                        2 == o &&
                            (i == s ? d.find('[data-compare-added="compare-' + e.id + '"]').html(r) : i == p ? l.find('[data-compare-added="compare-' + e.id + '"]').html(r) : c.find('[data-compare-added="compare-' + e.id + '"]').html(r)),
                        3 == o &&
                            (i == s ? d.find('[data-compare-added="compare-' + e.id + '"]').html(r) : i == p ? l.find('[data-compare-added="compare-' + e.id + '"]').html(r) : c.find('[data-compare-added="compare-' + e.id + '"]').html(r));
                }),
                    (u += "" == b || null == b ? '<div class="col-xl-3" data-compare-added="compare-' + e.id + '"></div>' : '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + b + "</div>"),
                    o.append(u),
                    (h += "" == C || null == C ? '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>' : '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + C + "</div>"),
                    i.append(h);
                var _ = e.variants;
                if (
                    (_.length > 1
                        ? t.each(_, function (t, a) {
                              0 == t &&
                                  ((skuValue = a.sku),
                                  "" == skuValue
                                      ? ((skuValueHTML = '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>'), (v += skuValueHTML))
                                      : ((skuValueHTML = '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + skuValue + "</div>"), (v += skuValueHTML)));
                          })
                        : (v += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">-</div>'),
                    s.append(v),
                    (p += '<div class="grid-item col-xl-3 product-item" data-compare-added="compare-' + e.id + '">'),
                    (p += '<div class="inner" data-product-id="product-' + e.handle + '"><div class="inner-top"'),
                    (p += '<div class="product-top"><div class="product-image">'),
                    (p += '<a href="' + e.url + '" class="product-grid-image" data-collections-related="/collections/all?view=related">'),
                    (p += '<img src="' + e.featured_image + '" alt="' + e.featured_image.alt + '">'),
                    (p += "</a></div>"),
                    (p += '<div class="product-label">'),
                    e.compare_at_price > e.price &&
                        ("label_sale" == window.label_sale
                            ? ((p += '<strong class="label sale-label">' + window.inventory_text.salelabel + " </strong>"), (p += "<br>"))
                            : ((p += '<strong class="label sale-label">- ' + x + "% </strong>"), (p += "<br>"))),
                    0 == e.available && ((p += '<strong class="label sold-out-label">' + window.inventory_text.soldoutlabel + " </strong>"), (p += "<br>")),
                    k.forEach(function (t) {
                        "new" == t && ((p += '<strong class="label new-label">' + window.inventory_text.newlabel + " </strong>"), (p += "<br>")),
                            "Custom Label" == t && ((p += '<strong class="label custom-label">' + window.inventory_text.customlabel + " </strong>"), (p += "<br>")),
                            "bundle" == t && ((p += '<strong class="label bundle-label">' + window.inventory_text.bundlelabel + " </strong>"), (p += "<br>"));
                    }),
                    (p += "</div></div></div>"),
                    (p += '<div class="product-bottom">'),
                    (p += '<div class="product-vendor">'),
                    (p += '<a href="/collections/vendors?q=' + e.vendor + '" title="' + e.vendor + '">' + e.vendor + "</a></div>"),
                    (p += '<a class="product-title" href="' + e.url + '" title="' + e.title + '">' + e.title + "</a>"),
                    (p += '<div class="column col-price text-center"><div class="price-box">'),
                    e.compare_at_price > e.price
                        ? ((p += '<span class="price-sale">'),
                          (p += '<span class="old-price">' + Shopify.formatMoney(e.variants[0].compare_at_price, window.money_format) + "</span>"),
                          (p += '<span class="price special-price" itemprop="price"> ' + Shopify.formatMoney(e.price, window.money_format) + "</span>"),
                          (p += "</span>"))
                        : (p += "<span> " + Shopify.formatMoney(e.price, window.money_format) + "</span>"),
                    (p += "</div></div>"),
                    (p += '<div class="column col-options text-center">'),
                    (p += '<form action="/cart/add" method="post" class="variants" id="-' + e.id + '" data-id="product-actions-' + e.id + '" enctype="multipart/form-data">'),
                    e.available
                        ? (1 == e.variants.length &&
                              (p +=
                                  '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" data-form-id="#-' +
                                  e.id +
                                  '" >' +
                                  window.inventory_text.add_to_cart +
                                  '</button><input type="hidden" name="id" value="' +
                                  e.variants[0].id +
                                  '" />'),
                          e.variants.length > 1 && (p += '<a class="btn" title="' + e.title + '" href="' + e.url + '">' + window.inventory_text.select_options + "</a>"),
                          (f += '<div class="col-xl-3 in-stock" data-compare-added="compare-' + e.id + '">' + window.inventory_text.in_stock + "</div>"))
                        : ((p += '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" disabled="disabled">' + window.inventory_text.unavailable + "</button>"),
                          (f += '<div class="col-xl-3 unavailable" data-compare-added="compare-' + e.id + '">' + window.inventory_text.unavailable + "</div>")),
                    (p += "</form></div>"),
                    (p +=
                        '<div class="column col-remove text-center"><a class="compare-added" href="#" data-icon-compare-added data-compare-product-handle="' +
                        e.handle +
                        '" data-id="' +
                        e.id +
                        '">' +
                        window.inventory_text.remove +
                        "</a></div></div>"),
                    (p += "</div></div></div>"),
                    a.append(p),
                    (m += '<div class="col-xl-3" data-compare-added="compare-' + e.id + '">' + e.type + "</div>"),
                    n.append(f),
                    r.append(m),
                    t(".spr-badge").length > 0)
                )
                    return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            });
        },
        removeCompareItem: function (e) {
            n.off("click.removeCompareItem", "[data-icon-compare-added]").on("click.removeCompareItem", "[data-icon-compare-added]", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this),
                    o = a.data("id"),
                    i = a.data("compare-product-handle"),
                    n = h.indexOf(i);
                t('[data-compare-added="compare-' + o + '"]').length && t('[data-compare-added="compare-' + o + '"]').remove(), h.splice(n, 1), localStorage.setItem("compareArr", JSON.stringify(h)), m.setAddedForCompareIcon(i);
            });
        },
        removeAllCompareItem: function (e) {
            (compareCountNum = t("[data-compare-count]")),
                (compareElm = t("[data-icon-compare]")),
                n.off("click.removeAllCompareItem", "[data-compare-remove-all]").on("click.removeAllCompareItem", "[data-compare-remove-all]", function (e) {
                    e.preventDefault(),
                        e.stopPropagation(),
                        t("[data-compare-added]").remove(),
                        h.splice(0, h.length),
                        localStorage.setItem("compareArr", JSON.stringify(h)),
                        compareElm.hasClass("compare-added") && compareElm.removeClass("compare-added"),
                        t(".compare-link").removeClass("open"),
                        (totalProduct = Math.ceil(h.length)),
                        compareCountNum.text(totalProduct);
                });
        },
        wrapTable: function () {
            var e = t(".tab-content").find("table");
            e.length &&
                e.each(function () {
                    t(this).wrap('<div class="table-wrapper"></div>');
                });
        },
        initBundleProducts: function () {
            var e,
                a = t("[data-bundle-images-slider]"),
                o = t(".products-grouped-action .bundle-price"),
                r = function () {
                    t(".fbt-product-item").each(function () {
                        var e = t(this),
                            a = e.data("bundle-product-id"),
                            o = t(this).find('[name="group_id"]').val(),
                            i = e.find(".swatch"),
                            n = window.productVariants[a];
                        if (n) {
                            var r = n.find(function (t) {
                                return t.id == o;
                            });
                            i.each(function (e) {
                                var a = "option" + (e + 1);
                                t(this)
                                    .find('.swatch-element[data-value="' + r[a] + '"]')
                                    .find("input")
                                    .prop("checked", !0);
                            });
                        }
                    });
                },
                s = function () {
                    var e = t(".fbt-product-item.isChecked"),
                        a = t(".products-grouped-action .bundle-price"),
                        o = t(".products-grouped-action .old-price"),
                        i = a.data("discount-rate"),
                        n = 0,
                        r = t(".fbt-product-item.isChecked").length,
                        s = t(".fbt-product-item").length;
                    e.each(function () {
                        var e = t(this).find("select[name=group_id]"),
                            d = t(this).find("input[name=group_id]");
                        if (e.length) var l = e.find(":selected").data("price");
                        else if (d.length) l = t(this).find("input[name=group_id]").data("price");
                        else l = t(this).find("input[name=id]").data("price");
                        l &&
                            ((n += l),
                            a.length > 0 &&
                                o.length > 0 &&
                                (o.html(Shopify.formatMoney(n, window.money_format)),
                                a.html(Shopify.formatMoney(n * (1 - i), window.money_format)),
                                r == s ? ((window.bundleMatch = !0), a.show(), o.show(), t(".products-grouped-action .price").hide()) : ((window.bundleMatch = !1), a.hide(), o.hide(), t(".products-grouped-action .price").show())),
                            t(".products-grouped-action .total .price").html(Shopify.formatMoney(n, window.money_format)));
                    }),
                        m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                },
                d = function (e) {
                    var a = e.data("bundle-product-id"),
                        o = window.productVariants[a],
                        i = e.find("[data-option-idx]"),
                        n = e.find('[data-option-idx="0"]').find("input:checked").val(),
                        r = e.find('[data-option-idx="1"]').find("input:checked").val();
                    e.find('[data-option-idx="2"]').find("input:checked").val();
                    i.each(function () {
                        var e = t(this).data("option-idx"),
                            a = t(this).find(".swatch-element");
                        switch (e) {
                            case 0:
                                a.each(function () {
                                    var e = t(this).data("value");
                                    null ==
                                        o.find(function (t) {
                                            return t.option1 == e && t.available;
                                        }) && (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0));
                                });
                                break;
                            case 1:
                                a.each(function () {
                                    var e = t(this).data("value");
                                    null ==
                                        o.find(function (t) {
                                            return t.option1 == n && t.option2 == e && t.available;
                                        }) && (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0));
                                });
                                break;
                            case 2:
                                a.each(function () {
                                    var e = t(this).data("value");
                                    null ==
                                        o.find(function (t) {
                                            return t.option1 == n && t.option2 == r && t.option3 == e && t.available;
                                        }) && (t(this).addClass("soldout"), t(this).find(":radio").prop("disabled", !0));
                                });
                        }
                    });
                };
            !(function () {
                if (o.length > 0) {
                    var e = 100 * o.data("discount-rate"),
                        a = t(".products-grouped-action .discount-text span");
                    a.length > 0 &&
                        a.each(function () {
                            t(this).text(t(this).text().replace("[discount]", e)).parent().show();
                        });
                }
            })(),
                (function () {
                    if (a.length && a.not(".slick-initialized")) {
                        var t = a.data("rows");
                        a.slick({
                            get slidesToShow() {
                                return (this.slidesToShow = t >= 5 ? 5 : t);
                            },
                            slidesToScroll: 1,
                            dots: !1,
                            infinite: !1,
                            speed: 800,
                            get nextArrow() {
                                return "layout_style_1170" == window.layout_style
                                    ? (this.nextArrow =
                                          '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                    : (this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>');
                            },
                            get prevArrow() {
                                return "layout_style_1170" == window.layout_style
                                    ? (this.prevArrow =
                                          '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>')
                                    : (this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>');
                            },
                            responsive: [
                                {
                                    breakpoint: 992,
                                    settings: {
                                        get slidesToShow() {
                                            return (this.slidesToShow = t >= 4 ? 4 : t);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 480,
                                    settings: {
                                        get slidesToShow() {
                                            return (this.slidesToShow = t > 3 ? 3 : t);
                                        },
                                    },
                                },
                            ],
                        });
                    }
                })(),
                i.off("click.toggleVariantOptions", ".fbt-toogle-options").on("click.toggleVariantOptions", ".fbt-toogle-options", function (e) {
                    e.preventDefault(), t(this).next().slideToggle();
                }),
                t(".fbt-checkbox input").prop("checked", !0),
                i.off("click.checkedProduct", ".bundle-checkbox").on("click.checkedProduct", ".bundle-checkbox", function (e) {
                    e.preventDefault();
                    var a = t(this),
                        o = a.prev(),
                        i = a.closest(".fbt-product-item").data("bundle-product-id");
                    o.prop("checked") ? (o.prop("checked", !1), t('[data-bundle-product-id="' + i + '"]').removeClass("isChecked")) : (o.prop("checked", !0), t('[data-bundle-product-id="' + i + '"]').addClass("isChecked")), s();
                }),
                r(),
                t(".fbt-product-item").each(function () {
                    var e = t(this);
                    d(e);
                }),
                (e = ".fbt-product-item .swatch :radio"),
                n.off("change.changeBundleSwatch", e).on("change.changeBundleSwatch", e, function (e) {
                    var a = t(this);
                    if (a.prop("checked")) {
                        var o,
                            i = t(this).closest(".fbt-product-item"),
                            n = i.data("bundle-product-id"),
                            l = window.productVariants[n],
                            c = a.closest("[data-option-idx]").data("option-idx"),
                            p = i.find(".swatch-element"),
                            u = a.val(),
                            h = i.find(".fbt-prices"),
                            f = h.find(".price-sale"),
                            v = h.find("[data-fbt-price-change]"),
                            g = i.find("[name=group_id]"),
                            w = i.find('[data-option-idx="0"]').find("input:checked").val(),
                            b = i.find('[data-option-idx="1"]').find("input:checked").val();
                        switch ((i.find('[data-option-idx="2"]').find("input:checked").val(), p.removeClass("soldout"), p.find(":radio").prop("disabled", !1), c)) {
                            case 0:
                                o =
                                    null !=
                                    (C = l.find(function (t) {
                                        return t.option1 == u && t.option2 == b && t.available;
                                    }))
                                        ? C
                                        : l.find(function (t) {
                                              return t.option1 == u && t.available;
                                          });
                                break;
                            case 1:
                                null !=
                                (C = l.find(function (t) {
                                    return t.option1 == w && t.option2 == u && t.available;
                                }))
                                    ? (o = C)
                                    : console.log("Bundle Error: variant was soldout, on option selection #2");
                                break;
                            case 2:
                                var C;
                                null !=
                                (C = l.find(function (t) {
                                    return t.option1 == w && t.option2 == b && t.option3 == u && t.available;
                                }))
                                    ? (o = C)
                                    : console.log("Bundle Error: variant was soldout, on option selection #3");
                        }
                        g.val(o.id),
                            r(),
                            d(i),
                            v.html(Shopify.formatMoney(o.price, window.money_format)),
                            i.find("input[name=id][type=hidden]").val(o.id),
                            o.compare_at_price > o.price
                                ? (f.find("[data-fbt-price-change]").addClass("special-price"), f.find(".old-price").html(Shopify.formatMoney(o.compare_at_price, window.money_format)).show())
                                : (f.find(".old-price").hide(), f.find("[data-fbt-price-change]").removeClass("special-price")),
                            i.find("select").val(o.id).trigger("change"),
                            s(),
                            m.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                        var y = g.find("option:selected", this).attr("data-image");
                        null != y &&
                            t('.fbt-image-item[data-bundle-product-id="' + n + '"]')
                                .find("img")
                                .attr("src", y);
                    }
                }),
                s(),
                n.off("click.bundleAddToCart", "[data-bundle-addToCart]").on("click.bundleAddToCart", "[data-bundle-addToCart]", function (e) {
                    e.preventDefault();
                    var a = t(this),
                        o = a.closest("form"),
                        i = o.find("[data-collections-related]"),
                        n = (i.data("collections-related"), o.find("[data-grouped-product-item].isChecked"));
                    t("h1.product-title").text(),
                        t('[id^="product-featured-image"]').first().attr("src"),
                        "disabled" !== a.attr("disabled") &&
                            (m.showLoading(),
                            (Shopify.queue = []),
                            n.each(function () {
                                var e = t(this).find("[name=group_id]").val();
                                e && Shopify.queue.push({ variantId: e, quantity: 1 });
                            }),
                            (Shopify.moveAlong = function () {
                                if (!Shopify.queue.length) {
                                    switch ((m.hideLoading(), i.find("[name=id]").val(), t(a.data("form-id")).serialize(), window.ajax_cart)) {
                                        case "none":
                                        case "normal":
                                        case "upsell":
                                            o.submit();
                                    }
                                    try {
                                        var e = "FBT-BUNDLE-" + meta.product.id;
                                        m.apply_discount(e);
                                    } catch (t) {
                                        console.log(t);
                                    }
                                    return !1;
                                }
                                var n = Shopify.queue.shift();
                                m.showLoading(),
                                    Shopify.addItem(n.variantId, n.quantity, Shopify.moveAlong),
                                    (m.ellaTimeout = setTimeout(function () {
                                        m.hideLoading();
                                    }, 5e3));
                            }),
                            Shopify.moveAlong());
                });
        },
        apply_discount: function (e) {
            window.bundleMatch &&
                t.ajax({
                    url: "/discount/" + e + "?redirect=/cart",
                    success: function (t) {
                        (window.location.href = "/discount/" + e + "?redirect=/cart"), console.log("Discount code added");
                    },
                });
        },
        checkBundleProducts: function () {
            var e = t.cookie("discount_code");
            if ("" != e && null != e) {
                var a = e.replace("FBT-BUNDLE-", "");
                "" != a &&
                    (function () {
                        if (t("ul.cart-list li").length > 0) {
                            var e = !1,
                                i = [];
                            t("ul.cart-list li").each(function (o, n) {
                                var r = t(n).data("product_id");
                                r == a && (e = !0), -1 == i.indexOf(r) && i.push(r);
                            }),
                                1 == e
                                    ? t.ajax({
                                          url: "/collections/bundle-" + a + "?view=bundle-json",
                                          success: function (t) {
                                              var e = JSON.parse(t);
                                              i.length >= e.results.length
                                                  ? (function (t, e) {
                                                        var a = 0;
                                                        e.forEach(function (e) {
                                                            -1 != t.indexOf(e.id) && a++;
                                                        }),
                                                            a != e.length && o();
                                                    })(i, e.results)
                                                  : o();
                                          },
                                      })
                                    : o();
                        }
                    })();
            }
            function o() {
                t.ajax({
                    url: "/checkout?discount=%20",
                    success: function (t) {
                        console.log("Discount code removed");
                    },
                });
            }
        },
        hide_filter: function () {
            t(".sidebar-tags .widget-content ul").each(function () {
                t(this).children("li").length > 0 ? t(this).parents(".sidebar-tags").show() : t(this).parents(".sidebar-tags").hide();
            });
        },
        productRecomendation: function () {
            var e = t(".js-product-recomendation"),
                a = e.data("productId"),
                o = e.data("template"),
                i = e.data("sectionId"),
                n = e.data("limit"),
                r = window.router + "/recommendations/products?&section_id=" + i + "&limit=" + n + "&product_id=" + a + " .product-recommendations";
            e.parent().load(r, function () {
                if (
                    ("" != o && t(".js-product-recomendation .products-grid").addClass("verticle"),
                    m.initSliderFeaturedProducts(),
                    m.translateBlock("#product-recommendations"),
                    t(".shopify-product-reviews-badge").length && t(".spr-badge").length)
                )
                    return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            });
        },
        appendProductRecomendation: function () {
            var e = t("#product-recommendations"),
                a = t(".template-product .product .product_bottom");
            (appenRecomendation1 = t(".template-product .product .product_bottom .relate-verticle")),
                (appenRecomendation2 = t(".template-product .product .relate-verticle").find("[data-sticky-3]")),
                e.appendTo(a),
                e.appendTo(appenRecomendation1),
                e.appendTo(appenRecomendation2);
        },
        checkbox_checkout: function () {
            var e = t(".checkbox-group label"),
                a = t('.checkbox-group input[type="checkbox"]');
            setTimeout(function () {
                a.each(function () {
                    t(this).is(":checked") ? t(this).parent().parent().find(".btn-checkout").removeClass("show") : t(this).parent().parent().find(".btn-checkout").addClass("show");
                });
            }, 300),
                e.off("click").on("click", function (e) {
                    var a = t(this).parent().find(".conditions"),
                        o = t(this).parent().parent().find(".btn-checkout");
                    a.is(":checked") ? (o.addClass("show"), a.prop("checked", !1)) : (o.removeClass("show"), a.prop("checked", !0));
                });
        },
        menu_ajax: function () {
            if (t(".site-nav").length)
                if (s.innerWidth() < 1025) {
                    var e = !1;
                    window.addEventListener(
                        "load",
                        function () {
                            document.body.addEventListener(
                                "touchstart",
                                function (a) {
                                    0 == e &&
                                        ((e = !0),
                                        t.ajax({
                                            url: "/search?view=mega",
                                            beforeSend: function () {},
                                            success: function (e) {
                                                var a = t(".site-nav"),
                                                    o = t(e).find(".site-nav");
                                                t(".wrapper_header_supermarket").length && ((a = t(".mb-area")), (o = t(e).find(".mb-area"))), t(a).replaceWith(o), m.initToggleSubMenuMobile(), m.sliderMegaMenu();
                                            },
                                            error: function (e, a) {
                                                alert(t.parseJSON(e.responseText).description);
                                            },
                                            complete: function () {},
                                        }));
                                },
                                !1
                            );
                        },
                        !1
                    ),
                        t("[data-menu-mb-toogle]").on("click", function (a) {
                            0 == e &&
                                ((e = !0),
                                t.ajax({
                                    url: "/search?view=mega",
                                    beforeSend: function () {},
                                    success: function (e) {
                                        var a = t(".site-nav"),
                                            o = t(e).find(".site-nav");
                                        t(".wrapper_header_supermarket").length && ((a = t(".mb-area")), (o = t(e).find(".mb-area"))), t(a).replaceWith(o), m.initToggleSubMenuMobile(), m.sliderMegaMenu();
                                    },
                                    error: function (e, a) {
                                        alert(t.parseJSON(e.responseText).description);
                                    },
                                    complete: function () {},
                                }));
                        });
                } else {
                    e = !1;
                    n.mousemove(function () {
                        0 == e &&
                            ((e = !0),
                            t.ajax({
                                url: "/search?view=mega",
                                beforeSend: function () {},
                                success: function (e) {
                                    var a = t(".site-nav"),
                                        o = t(e).find(".site-nav");
                                    t(".wrapper_header_supermarket").length && ((a = t(".mb-area")), (o = t(e).find(".mb-area"))),
                                        a.replaceWith(o),
                                        setTimeout(function () {
                                            m.sliderMegaMenu();
                                        }, 1e3);
                                },
                                error: function (e, a) {
                                    alert(t.parseJSON(e.responseText).description);
                                },
                                complete: function () {
                                    t("[data-masonry]").length && t(".site-nav-dropdown [data-masonry]").masonry({ columnWidth: ".grid-sizer", itemSelector: "[data-gridItem]" });
                                },
                            }));
                    });
                }
        },
        loaderScript: function () {
            var e = function () {
                var e = t("[data-loader-script]");
                e.length &&
                    e.each(function () {
                        var e = t(this),
                            a = e.data("loader-script"),
                            o = this.getBoundingClientRect().top;
                        e.hasClass("is-load") || (o < window.innerHeight + 100 && (m.buildScript(a), t('[data-loader-script="' + a + '"]').addClass("is-load")));
                    });
            };
            window.addEventListener("load", function () {
                e(), window.addEventListener("scroll", e);
            });
        },
        buildScript: function (t) {
            var e = document.createElement("script");
            (e.src = t), document.body.appendChild(e);
        },
        beforeYouLeave: function () {
            var e = t("#before-you-leave").find(".close"),
                a = t("#before-you-leave").find(".before-you-leave__bg #reload_page"),
                o = (t("#before-you-leave").find(".search"), t("#before-you-leave").find(".before-you-leave__wrapper").data("time"));
            if (t("#before-you-leave").length) {
                var i = 0;
                t(document).ready(function () {
                    setInterval(n, o);
                }),
                    t(document).on("mousemove", r).on("keydown", r).on("scroll", r),
                    a.on("click", function (e) {
                        e.preventDefault(), t("body").removeClass("open_beforeYouLeave");
                    }),
                    e.on("click", function (e) {
                        e.preventDefault(), t("body").removeClass("open_beforeYouLeave");
                    });
            }
            function n() {
                (i += 1) >= 1 && !t("body.open_beforeYouLeave").length && t("body").addClass("open_beforeYouLeave"), t(window).unbind("click");
            }
            function r() {
                i = 0;
            }
        },
        modal_open: function (e, a) {
            var o = { open: "open_" + a, openClass: "modal--is-active" };
            t(e).fadeIn("fast"), t(e).addClass(o.openClass), t("body").addClass(o.open);
        },
        modal_close: function (e, a) {
            var o = { open: "open_" + a, openClass: "modal--is-active" };
            t(e).fadeOut("fast"), t(e).removeClass(o.openClass), t("body").removeClass(o.open);
        },
        _addonShareAPI: function () {
            const e = t(".share_toolbox").attr("title"),
                a = t(".share_toolbox").data("href");
            navigator.share
                ? navigator
                      .share({ title: e, url: a })
                      .then(() => {
                          console.log("Thank for sharing!");
                      })
                      .cath(console.error)
                : (t(".share_toolbox .txt_copy").val(a), t(".share_toolbox .button").attr("data-url", a).attr("data-title", e), t(".share_toolbox .modal-title-text").text(e)),
                t(".close-button").click(function () {
                    t(".share-modal").removeClass("show-share"), t(".pen-url").removeClass("share-success");
                }),
                t(".copy-link").click(function () {
                    var e = t(this).prev(".txt_copy");
                    t(".pen-url").addClass("share-success"), e.select(), document.execCommand("copy");
                });
        },
        _addonCompareColorPopup: function () {
            t(".compareColor-link").length &&
                (t(document).on("click", ".compareColor-link", function (e) {
                    e.preventDefault();
                    var a = t("#compareColor-modal").find(".close"),
                        o = t("#compareColor-modal").find(".modal-content");
                    t("#compareColor-modal").length &&
                        (t("#compareColor-modal").addClass("modal--is-active").fadeIn("fast"),
                        a.on("click", function (e) {
                            e.preventDefault(), t("#compareColor-modal").removeClass("modal--is-active").fadeOut("fast");
                        }),
                        t("#compareColor-modal").on("click", function (e) {
                            t("#compareColor-modal").hasClass("modal--is-active") && 0 === t(e.target).closest(o).length && (e.preventDefault(), t("#compareColor-modal").removeClass("modal--is-active").fadeOut("fast"));
                        }));
                }),
                t(document).on("click", ".compareColor-swatch label", function (e) {
                    e.preventDefault(), t(".compareColor-swatch label").removeClass("disabled2");
                    var a = t(this),
                        o = a.prev(),
                        i = a.data("image");
                    ($value = a.data("value")),
                        ($value2 = a.html()),
                        ($limit = 0),
                        o.prop("checked")
                            ? (o.prop("checked", !1),
                              a
                                  .parents("#compareColor-modal")
                                  .find(".show-img ." + $value)
                                  .remove(),
                              ($limit = t("#compareColor-modal .show-img .item").length))
                            : (o.prop("checked", !0),
                              a
                                  .parents("#compareColor-modal")
                                  .find(".show-img")
                                  .append('<div class="item text-center ' + $value + '"><img srcset="' + i + '" alt="" /><p>' + $value2 + "</p></div>"),
                              ($limit = t("#compareColor-modal .show-img .item").length)),
                        $limit < 5 ? t(".compareColor-swatch label").removeClass("disabled2") : t(".compareColor-swatch label").addClass("disabled2");
                }));
        },
        _cartCountDown: function () {
            if (t(".cart__count_down").length) {
                var e,
                    a = t(".cart__count_down .count_down").data("time");
                t(document).ready(function () {
                    (fiveMinutes = 60 * a),
                        (display = document.querySelector("#time")),
                        (function (t, a) {
                            var o, i;
                            (e = t),
                                setInterval(function () {
                                    (o = parseInt(e / 60, 10)), (i = parseInt(e % 60, 10)), (o = o < 10 ? "0" + o : o), (i = i < 10 ? "0" + i : i), (a.textContent = o + ":" + i), --e < 0 && (e = t);
                                }, 1e3);
                        })(fiveMinutes, display);
                });
            }
        },
        _videoPopup: function () {
            t(".video-open-popup ").length &&
                (t(".video-open-popup a")
                    .off("click")
                    .on("click", function () {
                        t(this).attr("data-id");
                        var e = t(this).attr("data-src"),
                            a = t("[data-popup-video]");
                        const o =
                            '<div class="fluid-width-video-wrapper"><iframe                                        id="player"                                        type="text/html"                                        width="100%"                                        frameborder="0"                                        webkitAllowFullScreen                                        mozallowfullscreen                                        allowFullScreen                                        src="https://www.youtube.com/embed/' +
                            e +
                            '?autoplay=1&mute=1"                                        data-video-player>                                    </iframe></div>';
                        a.find(".halo-modal-body").html(o),
                            a.fadeIn(600, function () {
                                t("[data-ajax-cart-success]").is(":visible") && t("[data-ajax-cart-success]").hide();
                            });
                    }),
                t("[data-popup-video], [data-popup-video] .close-modal").on("click", function (e) {
                    var a = t("[data-popup-video] .halo-modal-body");
                    a.is(e.target) ||
                        a.has(e.target).length ||
                        t("[data-popup-video]").fadeOut(500, function () {
                            t("[data-popup-video] iframe").remove(), r.removeClass("halo-modal-open"), r.css({ overflow: "" });
                        });
                }));
        },
    };
})(jQuery);
